import { DcGameNew } from '../../models/dc/DcGame';

export const sample = [
  {
    houseId: 1,
    gameId: '525001',
    category: 'Crash Games',
    gameCode: 'CRASH88-CAV101-VR',
    gameName: 'AVIATORX',
    urlThumb: 'https://cdn.dreamdelhi.com/monk88/aviatorx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'CRASH88',
    subProviderName: 'CRASH88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '860001',
    category: 'Crash Games',
    gameCode: 'spribe_aviator',
    gameName: 'AVIATOR',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_aviator.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SPRIBE',
    subProviderName: 'SPRIBE',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900003',
    category: 'TABLE',
    gameCode: 'RG-TP01',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900021',
    category: 'TABLE',
    gameCode: 'RG-LK7101',
    gameName: 'Lucky7',
    urlThumb: 'https://cdn.dreamcasino.live/rg_lucky7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900001',
    category: 'TABLE',
    gameCode: 'RG-7UD01',
    gameName: '7 Up Down',
    urlThumb: 'https://cdn.dreamcasino.live/rg_7up_7down.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900013',
    category: 'TABLE',
    gameCode: 'RG-BCRIC01',
    gameName: 'Book Cricket',
    urlThumb: 'https://cdn.dreamcasino.live/rg_book_cricket.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900015',
    category: 'TABLE',
    gameCode: 'RG-MTP01',
    gameName: 'Muflis Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_muflis_teenpatti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900034',
    category: 'TABLE',
    gameCode: 'RG-SBC101',
    gameName: 'Side Bet City',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/side_bet_city.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900006',
    category: 'TABLE',
    gameCode: 'RG-BAC01',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/baccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900008',
    category: 'TABLE',
    gameCode: 'RG-3CJ01',
    gameName: '3 Cards Judgement',
    urlThumb: 'https://cdn.dreamcasino.live/rg_3cards_judgement.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900031',
    category: 'TABLE',
    gameCode: 'RG-DTL101',
    gameName: 'Dragon Tiger Lion',
    urlThumb: 'https://cdn.dreamcasino.live/rg_dtl.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900025',
    category: 'TABLE',
    gameCode: 'RG-2TP101',
    gameName: '2 Cards Teenpatti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_2card_tp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900002',
    category: 'TABLE',
    gameCode: 'RG-ART01',
    gameName: 'Auto Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/rg_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900004',
    category: 'TABLE',
    gameCode: 'RG-DT01',
    gameName: 'Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/rg_dragon_tiger.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900005',
    category: 'TABLE',
    gameCode: 'RG-CW01',
    gameName: 'Cricket War',
    urlThumb: 'https://cdn.dreamcasino.live/rg_cricket_war.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900007',
    category: 'TABLE',
    gameCode: 'RG-AAA01',
    gameName: 'Amar Akbar Anthony',
    urlThumb: 'https://cdn.dreamcasino.live/rg_a3.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900009',
    category: 'TABLE',
    gameCode: 'RG-CAW01',
    gameName: 'Casino War',
    urlThumb: 'https://cdn.dreamcasino.live/rg_casino_war.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900010',
    category: 'TABLE',
    gameCode: 'RG-WM01',
    gameName: 'Worli Matka',
    urlThumb: 'https://cdn.dreamcasino.live/rg_worli_matka.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900011',
    category: 'TABLE',
    gameCode: 'RG-BOC01',
    gameName: 'Bollywood Casino',
    urlThumb: 'https://cdn.dreamcasino.live/rg_bollywood_casino.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900012',
    category: 'TABLE',
    gameCode: 'RG-LOT01',
    gameName: 'Lottery',
    urlThumb: 'https://cdn.dreamcasino.live/rg_lottery.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900014',
    category: 'TABLE',
    gameCode: 'RG-HL01',
    gameName: 'HighLow',
    urlThumb: 'https://cdn.dreamcasino.live/rg_high_low.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900027',
    category: 'TABLE',
    gameCode: 'RG-1DT101',
    gameName: 'Dragon Tiger One day',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/dragon_tiger_one_day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900037',
    category: 'TABLE',
    gameCode: 'RG-TRI101',
    gameName: 'Trio',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/trio.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900039',
    category: 'TABLE',
    gameCode: 'RG-12TP101',
    gameName: '2 Card Teen Patti One Day?',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/2_card_teen_patti_one%20day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900046',
    category: 'TABLE',
    gameCode: 'RG-CC101',
    gameName: 'Center Card',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/center_card.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900075',
    category: 'TABLE',
    gameCode: 'RG-ROT101',
    gameName: 'Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901006',
    category: 'Virtual',
    gameCode: 'RG-BAC01-VR',
    gameName: 'VR Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/rg_baccarat_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901003',
    category: 'Virtual',
    gameCode: 'RG-TP01-VR',
    gameName: 'VR Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_teen_patti_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901021',
    category: 'Virtual',
    gameCode: 'RG-AB101',
    gameName: 'VR Andar Bahar',
    urlThumb: 'https://cdn.dreamcasino.live/rg_andar_bahar_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901020',
    category: 'Virtual',
    gameCode: 'RG-32C101',
    gameName: 'VR 32 Cards',
    urlThumb: 'https://cdn.dreamcasino.live/rg_32cards_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901026',
    category: 'Virtual',
    gameCode: 'RG-DTL101',
    gameName: 'VR Dragon Tiger Lion',
    urlThumb: 'https://cdn.dreamcasino.live/rg_dtl_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901014',
    category: 'Virtual',
    gameCode: 'RG-HL01-VR',
    gameName: 'VR HighLow',
    urlThumb: 'https://cdn.dreamcasino.live/rg_high_low_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901019',
    category: 'Virtual',
    gameCode: 'RG-2TP101',
    gameName: 'VR 2 Cards Teenpatti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_2card_tp_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901028',
    category: 'Virtual',
    gameCode: 'RG-LK7101',
    gameName: 'VR Lucky7',
    urlThumb: 'https://cdn.dreamcasino.live/rg_lucky7_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901007',
    category: 'Virtual',
    gameCode: 'RG-AAA01-VR',
    gameName: 'VR Amar Akbar Anthony',
    urlThumb: 'https://cdn.dreamcasino.live/rg_a3_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901034',
    category: 'Virtual',
    gameCode: 'RG-SPO101',
    gameName: 'VR Super Over',
    urlThumb: 'https://cdn.dreamcasino.live/rg_super_over_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901036',
    category: 'Virtual',
    gameCode: 'RG-TRI101',
    gameName: 'VR Trio',
    urlThumb: 'https://cdn.dreamcasino.live/rg_trio_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901015',
    category: 'Virtual',
    gameCode: 'RG-MTP01-VR',
    gameName: 'VR Muflis Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/rg_muflis_tp_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901030',
    category: 'Virtual',
    gameCode: 'RG-POK101',
    gameName: 'VR Poker',
    urlThumb: 'https://cdn.dreamcasino.live/rg_poker_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901004',
    category: 'Virtual',
    gameCode: 'RG-DT01-VR',
    gameName: 'VR Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/rg_dragon_tiger_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901023',
    category: 'Virtual',
    gameCode: 'RG-CAM101',
    gameName: 'VR Casino Meter',
    urlThumb: 'https://cdn.dreamcasino.live/rg_casino_meter_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901032',
    category: 'Virtual',
    gameCode: 'RG-RTT101',
    gameName: 'VR Race T20',
    urlThumb: 'https://cdn.dreamcasino.live/rg_king_race_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901008',
    category: 'Virtual',
    gameCode: 'RG-3CJ01-VR',
    gameName: 'VR 3 Cards Judgement',
    urlThumb: 'https://cdn.dreamcasino.live/rg_3cj_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901033',
    category: 'Virtual',
    gameCode: 'RG-SBC101',
    gameName: 'VR Side Bet City',
    urlThumb: 'https://cdn.dreamcasino.live/rg_sb_city_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901037',
    category: 'Virtual',
    gameCode: 'RG-TRP101',
    gameName: 'VR The Trap',
    urlThumb: 'https://cdn.dreamcasino.live/rg_the_trap_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901027',
    category: 'Virtual',
    gameCode: 'RG-FBS101',
    gameName: 'VR Foot Ball Studio',
    urlThumb: 'https://cdn.dreamcasino.live/rg_fb_studio_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901009',
    category: 'Virtual',
    gameCode: 'RG-CAW01-VR',
    gameName: 'VR Casino War',
    urlThumb: 'https://cdn.dreamcasino.live/rg_casino_war_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901022',
    category: 'Virtual',
    gameCode: 'RG-ARW101',
    gameName: 'VR Akbar Romeo Walter',
    urlThumb: 'https://cdn.dreamcasino.live/rg_arw_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901001',
    category: 'Virtual',
    gameCode: 'RG-7UD01-VR',
    gameName: 'VR 7 Up Down',
    urlThumb: 'https://cdn.dreamcasino.live/rg_7up_down_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901013',
    category: 'Virtual',
    gameCode: 'RG-BCRIC01-VR',
    gameName: 'VR Dus Kan Dum (Cards)',
    urlThumb: 'https://cdn.dreamcasino.live/rg_dus_kadum_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901005',
    category: 'Virtual',
    gameCode: 'RG-CW01-VR',
    gameName: 'VR Cricket War',
    urlThumb: 'https://cdn.dreamcasino.live/rg_cric_war_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901010',
    category: 'Virtual',
    gameCode: 'RG-WM01-VR',
    gameName: 'VR Worli Matka',
    urlThumb: 'https://cdn.dreamcasino.live/rg_worli_matka_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901012',
    category: 'Virtual',
    gameCode: 'RG-LOT01-VR',
    gameName: 'VR Lottery',
    urlThumb: 'https://cdn.dreamcasino.live/rg_lottery_vr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900000',
    category: 'TABLE',
    gameCode: 'RG-LIVELOBBY',
    gameName: 'Royal Gaming Live Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/rg_live_lobby.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100082',
    category: 'Live Roulette',
    gameCode: 'ezg_ultimate_roulette',
    gameName: 'Ultimate Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/ezugi/ultimate_roulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100063',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamcasino.live/andar_bahar_228000.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_andarbahar.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100029',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Namaste Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/namaste-roulette-thumb-v2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: true,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100027',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Speed Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/speed_roulette_221000.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_speedroulette.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100044',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Ruleta del Sol',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_ruleta-del-sol-thumb.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/ezg_ruleta-del-sol-bg.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100034',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Automatic Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/auto-roulette-thumbb.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/auto-roulette-bgg.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100064',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'OTT Andar Bahar',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ott-ab-thumbnail.webp',
    urlBackground: 'http://cdn.hub88.io/ezugi/ott-ab-bg.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100066',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Lucky 7',
    urlThumb: 'https://cdn.dreamcasino.live/lucky7_228001.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100061',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_dragontiger.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_dragontiger.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100048',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'One Day Teen Patti Classic',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_onedayteenpatticlassic.webp',
    urlBackground:
      'https://cdn.hub88.io/ezugi/bg/ezg_onedayteenpatticlassic.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: true,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100047',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Bet on Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/beton_teenpatti.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100068',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Sic Bo',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/sicbo-thumbnail.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/sicbo-bg.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100060',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'No Commission Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/no_commission_baccarat_170.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_nocommissionbaccarat.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100054',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Marina Casino Baccarat 1',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_marinacasinobaccarat1.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100030',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Cumbia Ruleta 1',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_cumbiaruleta1.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100028',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Diamond Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/diamond-roulette-thumb-v2.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/diamond-roulette-bg.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100022',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Unlimited Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_unlimitedblackjack.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_unlimitedblackjack.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100046',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/teen_patti_227100.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_teenpatti.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100005',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Gold 3',
    urlThumb: 'https://cdn.dreamcasino.live/gold_blackjack_1.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_blackjackgold3.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100062',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Cricket War ',
    urlThumb: 'https://cdn.dreamcasino.live/cricket_war.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100055',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Marina Casino Baccarat 2',
    urlThumb: 'https://cdn.dreamcasino.live/marina_casino_baccarat_2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100056',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Marina Casino Baccarat 3',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_OTT_Baccarat_3-thumb.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100057',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Marina Casino Baccarat 4',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_OTT_Baccarat_4-thumb.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100058',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat Knockout',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_goldenbaccaratknockout.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100059',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat Super Six',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_baccaratsuper6.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100026',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Italian Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/italian roulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100023',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Unlimited Turkish Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/unlimited_blackjack_turkish.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100031',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Türkçe Rulet',
    urlThumb: 'https://cdn.dreamcasino.live/turkish_roulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100032',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Ruletka Russia',
    urlThumb: 'https://cdn.dreamcasino.live/ruletka russia.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100045',
    category: 'Live Poker',
    gameCode: '',
    gameName: "Casino Hold'em",
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_casinoholdem.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_casinoholdem.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100049',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_baccarat.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100036',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Prestige Auto Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_prestigeautoroulette.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_prestigeautoroulette.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100037',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Portomaso Casino Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_portomasocasinoroulette.webp',
    urlBackground:
      'https://cdn.hub88.io/ezugi/bg/ezg_portomasocasinoroulette.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100038',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Oracle Casino Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/oracle_roulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100039',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Oracle Casino Roulette 360',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_oraclecasinoroulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100042',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Marina Casino Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_marinacasinoroulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100043',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Marina Casino Roulette2',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/ezg_OTT_roulette_2-thumb.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100050',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat- Cricket',
    urlThumb: 'https://cdn.dreamcasino.live/speed_bacaratt_cricket.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_speedcricketbaccarat.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100001',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Gold 5',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_blackjackgold5.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_blackjackgold5.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100003',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Platinum 1',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_blackjackplatinum1.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_blackjackplatinum1.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100035',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Speed Auto Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/ezg_speedautoroulette.webp',
    urlBackground: 'https://cdn.hub88.io/ezugi/bg/ezg_speedautoroulette.jpg',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100006',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Gold 1',
    urlThumb: 'https://cdn.dreamcasino.live/gold_blackjack_2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100008',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Gold 6',
    urlThumb: 'https://cdn.dreamcasino.live/gold_blackjack_3.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100009',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'VIP Blackjack with Surrender',
    urlThumb:
      'https://cdn.dreamcasino.live/ezugi/vip-bj-surrender-thumb-v2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100010',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'VIP Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/vip-bj-thumb-v2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100013',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Rumba Blackjack 2',
    urlThumb: 'https://cdn.dreamcasino.live/rumba_blackjack_2.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100024',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Mambo Unlimited Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/ezugi/440x528+ubj++es.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200195',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Speed Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200257',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Indian Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_indianroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200194',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Auto-Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveauto-roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200200',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Speed Auto Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedautoroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200201',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Auto-Roulette VIP',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveauto-roulettevip.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200295',
    category: 'Others',
    gameCode: '',
    gameName: 'Fan Tan',
    urlThumb: 'https://cdn.dreamcasino.live/evo_fantan.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200212',
    category: 'Others',
    gameCode: '',
    gameName: 'Football Studio',
    urlThumb: 'https://cdn.dreamcasino.live/evo_footballstudio.webp',
    urlBackground: 'https://cdn.dreamcasino.live/football-studio-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200249',
    category: 'Others',
    gameCode: '',
    gameName: 'Craps',
    urlThumb: 'https://cdn.dreamcasino.live/Craps_Thumbnail.webp',
    urlBackground: 'https://cdn.dreamcasino.live/Craps_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200211',
    category: 'Others',
    gameCode: '',
    gameName: 'Dream Catcher',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livedreamcatcher.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200237',
    category: 'Others',
    gameCode: '',
    gameName: 'Mega Ball',
    urlThumb: 'https://cdn.dreamcasino.live/MegaBall_Thumbnail.webp',
    urlBackground: 'https://cdn.dreamcasino.live/MegaBall_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200223',
    category: 'Others',
    gameCode: '',
    gameName: 'Deal or No Deal',
    urlThumb: 'https://cdn.dreamcasino.live/evo_dealnodeal.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200139',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/evo_dragontiger.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200205',
    category: 'Live Poker',
    gameCode: '',
    gameName: "Casino Hold'em",
    urlThumb: 'https://cdn.dreamcasino.live/evo_livecasinoholdem.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200210',
    category: 'Live Poker',
    gameCode: '',
    gameName: "Texas Hold'em Bonus Poker",
    urlThumb: 'https://cdn.dreamcasino.live/evo_texasholdembonuspoker.webp',
    urlBackground:
      'https://cdn.dreamcasino.live/evolution/texhas-holdem-bonus-poker-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200150',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'No Commission Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/evo_nocommissionbaccarat.webp',
    urlBackground: 'https://cdn.dreamcasino.live/baccarat-nocommision-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200140',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarata.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200154',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat Squeeze',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratsqueeze.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200163',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200159',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Free Bet Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/evo_freebetblackjack.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200165',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200252',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP Alpha',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipr.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200242',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Power Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/evo_powerblackjack.webp',
    urlBackground: 'https://cdn.dreamcasino.live/powerblackjack-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200193',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Immersive Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveimmersiveroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200160',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Infinite Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/evo_infiniteblackjack.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203840',
    category: 'Virtual Sports',
    gameCode: 'pgp_steeplechase',
    gameName: 'Steeplechase',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_steeplechase.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203841',
    category: 'Virtual Sports',
    gameCode: 'pgp_force_1',
    gameName: 'Force 1',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_force_1.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203842',
    category: 'Virtual Sports',
    gameCode: 'pgp_fantastic_league',
    gameName: 'Fantastic League',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_fantastic_league.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203843',
    category: 'Virtual Sports',
    gameCode: 'pgp_greyhound_racing',
    gameName: 'Greyhound Racing',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_greyhound_racing.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203844',
    category: 'Virtual Sports',
    gameCode: 'pgp_penalty_shootout',
    gameName: 'Penalty Shootout',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_penalty_shootout.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203845',
    category: 'Virtual Sports',
    gameCode: 'pgp_horse_racing',
    gameName: 'Horse Racing',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/pgp_horse_racing.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play 2',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204053',
    category: 'Live Roulette',
    gameCode: 'evo_lightning_roulette',
    gameName: 'Lightning Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/lightning_roulette_thumbnail.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204055',
    category: 'Live Game Shows',
    gameCode: 'evo_monopoly_live',
    gameName: 'MONOPOLY Live',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_monopoly_live.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '400002',
    category: 'Live Baccarat',
    gameCode: 'MX-LIVE-002',
    gameName: 'Baccarat',
    urlThumb:
      'https://cdn.dreamcasino.live/gap_casino/awc_aesexy/aes_baccarat.webp',
    urlBackground:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/awc_aesexy/AE_SEXY_Logo.png',
    trendingThumbnail: '',
    providerName: 'AWC',
    subProviderName: 'SEXYBCRT',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '400004',
    category: 'Live Popular',
    gameCode: 'MX-LIVE-006',
    gameName: 'DragonTiger',
    urlThumb:
      'https://cdn.dreamcasino.live/gap_casino/awc_aesexy/aes_dragon_tiger.webp',
    urlBackground:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/awc_aesexy/Dragontige_RB B.jpg',
    trendingThumbnail: '',
    providerName: 'AWC',
    subProviderName: 'SEXYBCRT',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '600011',
    category: 'Live Popular',
    gameCode: 'jili_teenpatti',
    gameName: 'TeenPatti',
    urlThumb: 'https://cdn.dreamcasino.live/jili/Jili_Teen_Patti.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'JiLi',
    subProviderName: 'JiLi Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201203',
    category: 'Casual Games',
    gameCode: 'sbe_keno',
    gameName: 'KENO',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_keno.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201204',
    category: 'Casual Games',
    gameCode: 'sbe_roulette',
    gameName: 'ROULETTE',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201205',
    category: 'Casual Games',
    gameCode: 'sbe_hilo',
    gameName: 'HILO',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_hilo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201207',
    category: 'Casual Games',
    gameCode: 'sbe_dice',
    gameName: 'DICE',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_dice.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201208',
    category: 'Casual Games',
    gameCode: 'sbe_mines',
    gameName: 'MINES',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_mines.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201209',
    category: 'Casual Games',
    gameCode: 'sbe_plinko',
    gameName: 'PLINKO',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_plinko.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201210',
    category: 'Casual Games',
    gameCode: 'sbe_goal',
    gameName: 'GOAL',
    urlThumb: 'https://cdn.dreamcasino.live/sbe_goal.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200526',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Roll The Dice',
    urlThumb: 'https://cdn.dreamdelhi.com/evp/evp_rollthedice.webp',
    urlBackground: 'https://cdn.dreamcasino.live /evp_rollthedice.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evoplay Entertainment',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200171',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipa.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200166',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver3.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200167',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver4.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200168',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver E',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver5.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200169',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver F',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver6.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200170',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver G',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200172',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200173',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200174',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200175',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP E',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipe.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200176',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP G',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipg.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200177',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP H',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackviph.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200178',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP I',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackvipi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200179',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP L',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipl.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200180',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP M',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipm.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200181',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP O',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200182',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP P',
    urlThumb:
      'https://cdn.dreamcasino.live/2019_mar_live_blackjack_male_dealer_holding_bonus_card_11350_1987_1.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200225',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed Blackjack A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedblackjacka.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200141',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccaratb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200142',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccaratc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200143',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccaratd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200144',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat E',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarate.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200145',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat F',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccaratf.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200146',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat G',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccaratg.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200147',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat H',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarath.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200158',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200192',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200239',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'First Person Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersondragontiger.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200208',
    category: 'Live Poker',
    gameCode: '',
    gameName: 'Triple Card Poker',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livetriplecardpoker.webp',
    urlBackground: 'https://cdn.dreamcasino.live/evo_pokerlobby2.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200151',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccarata.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200152',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200153',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200207',
    category: 'Live Poker',
    gameCode: '',
    gameName: "Extreme Texas Hold'em",
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveextremetexasholdem.webp',
    urlBackground: 'https://cdn.dreamcasino.live/evo_pokerlobby2.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200161',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Party',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackparty.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200162',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200164',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Silver A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacksilver1.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200197',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'French Roulette Gold',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livefrenchroulettegold.webp',
    urlBackground: 'https://cdn.dreamcasino.live/evo_liveroulettelobbytest.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200138',
    category: 'Live Popular',
    gameCode: '',
    gameName: 'Super Sic Bo',
    urlThumb: 'https://cdn.dreamcasino.live/evo_supersicbo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200198',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'American Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveamericanroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200199',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Double Ball Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livedoubleballroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200236',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP F',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipf.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200202',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Benelux Slingshot (Auto-Roulette La Partage)',
    urlThumb:
      'https://cdn.dreamcasino.live/evo_livebeneluxslingshotauto-roulettelapartage.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200183',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP R',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200184',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP S',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvips.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200185',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP T',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipt.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200219',
    category: 'Others',
    gameCode: '',
    gameName: 'First Person Dream Catcher',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersondreamcatcher.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200221',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Game Shows Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_gameshowslobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200186',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Platinum VIP',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackplatinumvip.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200149',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'No Comm Speed Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/evo_nocommspeedbaccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200187',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Fortune VIP',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackfortunevip.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200188',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Grand VIP',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackgrandvip.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200189',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack Diamond VIP',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjackdiamondvip.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200190',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonpriveblackjack1.webp',
    urlBackground:
      'https://cdn.dreamcasino.live/bg_evo_salonpriveblackjack1.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200214',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Baccarat Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratlobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200215',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'TopCard Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_topcardlobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200224',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivbaccarat2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200235',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat J',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedbaccaratj.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200191',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack Ð¡',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonpriveblackjack2.webp',
    urlBackground:
      'https://cdn.dreamcasino.live/bg_evo_salonpriveblackjack2.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200213',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Blackjack Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacklobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200218',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'First Person Blackjack',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersonblackjack.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200226',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed Blackjack B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedblackjackb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200227',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed Blackjack C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedblackjackc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200228',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed Blackjack D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_speedblackjackd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200206',
    category: 'Live Poker',
    gameCode: '',
    gameName: "2 Hand Casino Hold'em",
    urlThumb: 'https://cdn.dreamcasino.live/evo_2handcasinoholdem.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200209',
    category: 'Live Poker',
    gameCode: '',
    gameName: 'Caribbean Stud Poker',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livecaribbeanstudpoker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200220',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Poker Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_pokerlobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200229',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Three Card Poker Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/threecardpoker-thumb.webp',
    urlBackground: 'https://cdn.dreamcasino.live/threecardpoker-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200230',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Ultimate Texas Holdem Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_ultimatetexasholdemlobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200238',
    category: 'Others',
    gameCode: '',
    gameName: 'First Person Mega Ball',
    urlThumb: 'https://cdn.dreamcasino.live/FirstPersonMegaBall_Thumbnail.webp',
    urlBackground: 'https://cdn.dreamcasino.live/FirstPersonMegaBall_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200243',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Instant Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/instant-roulette-thumbnail.webp',
    urlBackground: 'https://cdn.dreamcasino.live/instant-roulette-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200240',
    category: 'Others',
    gameCode: '',
    gameName: 'First Person Top Card',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersontopcard.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200273',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Brazilian Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_brazilianroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200232',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Scalable Blackjack Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_scalableblackjacklobby.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200233',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP Q',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipq.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200255',
    category: 'Others',
    gameCode: '',
    gameName: 'First Person Craps',
    urlThumb: 'https://cdn.dreamcasino.live/craps-first-person-thumbnail.webp',
    urlBackground: 'https://cdn.dreamcasino.live/craps-first-person-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200241',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'First Person Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersonbaccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200292',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'First Person American Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/evo_firstpersonamericanroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200247',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivbaccaratc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200248',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivbaccaratd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200234',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP Z',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipz.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200216',
    category: 'Live Lobby',
    gameCode: '',
    gameName: 'Roulette Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/roulette-lobby-thumb.webp',
    urlBackground: 'https://cdn.dreamcasino.live/roulette-lobby-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200296',
    category: 'Others',
    gameCode: '',
    gameName: 'Evolution Top Games',
    urlThumb: 'https://cdn.dreamcasino.live/evo_topgames.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200217',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'First Person Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersonroulette.webp',
    urlBackground: 'https://cdn.dreamcasino.live/RNG-Roulette-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200293',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Japanese Speed Baccarat A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_japanesespeedbaccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200244',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivblackjackb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200245',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack D',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivblackjackd.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200246',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack F',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivblackjackf.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200545',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Baccarat 777',
    urlThumb: 'https://cdn.dreamcasino.live/evp_baccarat777.webp',
    urlBackground: 'https://cdn.dreamcasino.live /evp_baccarat777.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evoplay Entertainment',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200529',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'BlackJack Lucky Sevens',
    urlThumb: 'https://cdn.dreamcasino.live/evp_blackjackluckysevens.webp',
    urlBackground: 'https://cdn.dreamcasino.live /evp_blackjackluckysevens.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evoplay Entertainment',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200577',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Texas Holdem Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/evp/evp_texasholdempoker.webp',
    urlBackground: 'https://cdn.dreamcasino.live /evp_texasholdempoker.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evoplay Entertainment',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200155',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Baccarat Control Squeeze',
    urlThumb:
      'https://cdn.dreamcasino.live/evo_livebaccaratcontrolsqueeze.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200156',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivbaccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201276',
    category: 'Video Slots',
    gameCode: 'clt_catchafishbingo',
    gameName: 'Catch a Fish Bingo',
    urlThumb: 'https://cdn.dreamcasino.live/CatchAFish_Thumbnail.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Caleta Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201283',
    category: 'Video Slots',
    gameCode: 'clt_bingohalloween',
    gameName: 'Bingo Halloween',
    urlThumb: 'https://cdn.dreamcasino.live/clt_bingohalloween.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Caleta Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201344',
    category: 'Live Baccarat',
    gameCode: 'ppl_live-baccaratd',
    gameName: 'Live - Baccarat D',
    urlThumb: 'https://cdn.dreamcasino.live/pragmatic/pgp_baccaratd.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201363',
    category: 'Live Baccarat',
    gameCode: 'ppl_live-speedbaccarata',
    gameName: 'Live - Speed Baccarat A',
    urlThumb:
      'https://cdn.dreamcasino.live/pragmatic/pgp_live-speedbaccarata.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201364',
    category: 'Live Baccarat',
    gameCode: 'ppl_live-baccarate',
    gameName: 'Live - Baccarat E',
    urlThumb: 'https://cdn.dreamcasino.live/pragmatic/pgp_baccarate_tb.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201371',
    category: 'Live Baccarat',
    gameCode: 'ppl_live-speedbaccarate',
    gameName: 'Live - Speed Baccarat E',
    urlThumb:
      'https://cdn.dreamcasino.live/pragmatic/ppl_live-speedbaccarate.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Pragmatic Play Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200157',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack A',
    urlThumb: 'https://cdn.dreamcasino.live/evo_liveblackjacka.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200253',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP Beta',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipr.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200283',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 9',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200284',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 10',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200285',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 11',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200286',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 12',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200287',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 13',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200288',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 14',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200289',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 15',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200290',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 16',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200294',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Salon Privé Blackjack E',
    urlThumb: 'https://cdn.dreamcasino.live/evo_salonprivblackjackd.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200266',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack G',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_g.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200265',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack E',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_e.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200254',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP Gamma',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipl.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200264',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat P',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200263',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat O',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200262',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat N',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200261',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat M',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200260',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat L',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200259',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Korean speaking Speed Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200258',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'No Comm Speed Baccarat C',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratc.webp',
    urlBackground: 'https://cdn.dreamcasino.live/baccarat-nocommision-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200231',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'First Person Baccarat Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/evo_firstpersonbaccarat.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200148',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat I',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livespeedbaccarati.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200250',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat K',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_baccarat_k.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200251',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'No Comm Speed Baccarat B',
    urlThumb: 'https://cdn.dreamcasino.live/evo_livebaccaratc.webp',
    urlBackground: 'https://cdn.dreamcasino.live/baccarat-nocommision-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200256',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP X',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvipr.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200267',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack H',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_h.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200268',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack I',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_i.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200269',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack J',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_j.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200270',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack K',
    urlThumb: 'https://luckmedia.link/evo_speed_blackjack_k/thumb.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200271',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack M',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_m.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200272',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Blackjack L',
    urlThumb: 'https://luckmedia.link/evo_speed_blackjack_l/thumb.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200274',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Speed Baccarat Q',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/evo_speed_blackjack_q.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200275',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 1',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200276',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 2',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200277',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 3',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200278',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 4',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200279',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 5',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200280',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 6',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200281',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 7',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '200282',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Blackjack VIP 8',
    urlThumb: 'https://cdn.dreamcasino.live/evo_blackjackvip.webp',
    urlBackground: '  ',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '100075',
    category: 'andar_bahar',
    gameCode: 'ezg_ultimate_andar_bahar',
    gameName: 'Ultimate Andar Bahar',
    urlThumb:
      'https://hx-app-assets.s3.eu-west-2.amazonaws.com/gap_casino/ezg_ultimate_andarbahar.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'EZUGI',
    subProviderName: 'Ezugi',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203905',
    category: 'Live Baccarat',
    gameCode: 'pltl_baccarat',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/pltl_baccarat/thumb.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Playtech Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203908',
    category: 'Live Baccarat',
    gameCode: 'pltl_grand_baccarat',
    gameName: 'Grand Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/pltl_grand_baccarat/thumb.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Playtech Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204109',
    category: 'Crash Games',
    gameCode: 'sms_jetx',
    gameName: 'JetX',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_jetx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204110',
    category: 'Crash Games',
    gameCode: 'sms_cappadocia',
    gameName: 'Cappadocia',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_cappadocia.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204111',
    category: 'Crash Games',
    gameCode: 'sms_jetx3',
    gameName: 'JetX3',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_jetx3.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204112',
    category: 'Crash Games',
    gameCode: 'sms_baloon',
    gameName: 'Baloon',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_baloon.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204113',
    category: 'Crash Games',
    gameCode: 'sms_cricketx',
    gameName: 'CricketX',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_cricketx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204114',
    category: 'Video Slots',
    gameCode: 'sms_samurai',
    gameName: 'Samurai',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_samurai.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204115',
    category: 'Video Slots',
    gameCode: 'sms_burning_ice_40',
    gameName: 'Burning Ice 40',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_burning_ice_40.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204126',
    category: 'Crash Games',
    gameCode: 'sms_spinx',
    gameName: 'SpinX',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_spinx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204131',
    category: 'Video Slots',
    gameCode: 'sms_vampires',
    gameName: 'Vampires',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_vampires.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204132',
    category: 'Video Slots',
    gameCode: 'sms_burning_ice',
    gameName: 'Burning Ice',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_burning_ice.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204133',
    category: 'Video Slots',
    gameCode: 'sms_burning_ice_10',
    gameName: 'Burning Ice 10',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_burning_ice_10.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204140',
    category: 'Casual Games',
    gameCode: 'sms_plinkox',
    gameName: 'PlinkoX',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_plinkox.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204141',
    category: 'Video Slots',
    gameCode: 'sms_multi_hot_5',
    gameName: 'Multi Hot 5',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_multi_hot_5.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204142',
    category: 'Crash Games',
    gameCode: 'sms_footballx',
    gameName: 'FootballX',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_footballx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204143',
    category: 'Video Slots',
    gameCode: 'sms_wild_jungle',
    gameName: 'Wild Jungle',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_wild_jungle.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204195',
    category: 'Video Slots',
    gameCode: 'sms_genies_bonanza',
    gameName: "Genie's Bonanza",
    urlThumb: 'https://cdn.dreamdelhi.com/sms/geniesbonanza.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '210048',
    category: 'Live casino',
    gameCode: 'evo_red_door_roulette',
    gameName: 'Red Door Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_red_door_roulette/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '221010',
    category: 'Live Baccarat',
    gameCode: 'pltl_emperor_baccarat',
    gameName: 'Emperor Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/pltl_emperor_baccarat/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Playtech Live',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '222001',
    category: 'Crash Games',
    gameCode: 'sms_towerx',
    gameName: 'TowerX',
    urlThumb: 'https://cdn.dreamcasino.live/sms_towerx/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '222002',
    category: 'Crash Games',
    gameCode: 'sms_slicerx',
    gameName: 'SlicerX',
    urlThumb: 'https://cdn.dreamcasino.live/sms_slicerx/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '222004',
    category: 'Crash Games',
    gameCode: 'sms_multi_hot_ways',
    gameName: 'Multi Hot Ways',
    urlThumb: 'https://cdn.dreamcasino.live/sms_multi_hot_ways/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '222005',
    category: 'Crash Games',
    gameCode: 'sms_hunter_x',
    gameName: 'Hunter X',
    urlThumb: 'https://cdn.dreamcasino.live/sms_hunter_x/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '222006',
    category: 'Crash Games',
    gameCode: 'sms_helicopter_x',
    gameName: 'Helicopter X',
    urlThumb: 'https://cdn.dreamcasino.live/sms_helicopter_x/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '223001',
    category: 'Casual Games',
    gameCode: 'evo_xxxtreme_lightning_baccarat',
    gameName: 'XXXtreme Lightning Baccarat',
    urlThumb:
      'https://cdn.dreamcasino.live/evo_xxxtreme_lightning_baccarat/thumb.webp',
    urlBackground: null,
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '223001',
    category: 'Casual Games',
    gameCode: 'spb_hotline',
    gameName: 'Hotline',
    urlThumb: 'https://cdn.dreamcasino.live/spb_hotline/thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Spribe',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500001',
    category: 'LIVE',
    gameCode: 'TP',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500002',
    category: 'LIVE',
    gameCode: 'BAC',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/Baccarat_1654236281166.404.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500005',
    category: 'LIVE',
    gameCode: 'ARW',
    gameName: 'Akbar Romeo Walter',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/akbar_romeo_walter.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500006',
    category: 'LIVE',
    gameCode: 'C32',
    gameName: '32 Cards',
    urlThumb:
      'https://cdn.dreamdelhi.com/suno/32-Cards_1654236218602.8164.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500007',
    category: 'LIVE',
    gameCode: 'UD7',
    gameName: 'Lucky 7',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/Lucky-7_1657523911243.0068.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500010',
    category: 'LIVE',
    gameCode: 'ABC',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/andar_bahar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500012',
    category: 'LIVE',
    gameCode: 'AB2',
    gameName: "Goa's Andar Bahar",
    urlThumb: 'https://cdn.dreamdelhi.com/suno/goa_andar_bahar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500014',
    category: 'LIVE',
    gameCode: 'TPFO',
    gameName: 'Teen patti face off',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/teen_patti_faceoff.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500015',
    category: 'LIVE',
    gameCode: 'TP20',
    gameName: 'Teen patti 2020',
    urlThumb:
      'https://cdn.dreamdelhi.com/suno/Teen-Patti-2020_1654236450045.9844.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500016',
    category: 'LIVE',
    gameCode: 'AB',
    gameName: 'Classic Andar Bahar',
    urlThumb:
      'https://cdn.dreamdelhi.com/suno/Andar-Bahar_1654236263135.5576.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500017',
    category: 'LIVE',
    gameCode: 'MTP7M',
    gameName: 'Muflis Teen patti',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/muflis_teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500201',
    category: 'VIRTUAL',
    gameCode: 'VTP',
    gameName: 'Virtual Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/teen_patti_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500202',
    category: 'VIRTUAL',
    gameCode: 'VBAC',
    gameName: 'Virtual Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_baccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500203',
    category: 'VIRTUAL',
    gameCode: 'VDT',
    gameName: 'Virtual Dragon Tiger',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_dragon_tiger.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500205',
    category: 'VIRTUAL',
    gameCode: 'VWM',
    gameName: 'Virtual Worli Matka',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/worli_matka_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500206',
    category: 'VIRTUAL',
    gameCode: 'VARW',
    gameName: 'Virtual Akbar Romeo Walter',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_akbat_romeo_walter.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500207',
    category: 'VIRTUAL',
    gameCode: 'VTP20',
    gameName: 'Virtual Teenpatti 2020',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/3patti2020_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500208',
    category: 'VIRTUAL',
    gameCode: 'VC32',
    gameName: 'Virtual 32 Cards',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_32_cards.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500210',
    category: 'VIRTUAL',
    gameCode: 'VUD7',
    gameName: 'Virtual 7 Up Down',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/lucky_7_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500212',
    category: 'VIRTUAL',
    gameCode: 'VDT20',
    gameName: 'Virtual Dragon Tiger 2020',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/dragon_tiger_2020_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500213',
    category: 'VIRTUAL',
    gameCode: 'VCR',
    gameName: 'Virtual King Race',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/king_race_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500215',
    category: 'VIRTUAL',
    gameCode: 'V3TP',
    gameName: 'Virtual 3Player Teen patti',
    urlThumb:
      'https://cdn.dreamdelhi.com/suno/virtual_3_player_teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500217',
    category: 'VIRTUAL',
    gameCode: 'VJKR',
    gameName: 'Virtual Joker',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/joker_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500218',
    category: 'VIRTUAL',
    gameCode: 'RCQ',
    gameName: 'Virtual Casino Queen',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_casino_queen.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '500219',
    category: 'VIRTUAL',
    gameCode: 'RCQ20',
    gameName: 'Virtual Casino Queen 2020',
    urlThumb: 'https://cdn.dreamdelhi.com/suno/virtual_casino_queen_2020.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'SUNO',
    subProviderName: 'SuperNowa',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901002',
    category: 'Virtual',
    gameCode: 'RG-ART01-VR',
    gameName: 'VR Auto Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/roulette_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901016',
    category: 'Virtual',
    gameCode: 'RG-1DT101-VR',
    gameName: 'VR Dragon Tiger One day',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/dragon_tiger_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901017',
    category: 'Virtual',
    gameCode: 'RG-1TP101-VR',
    gameName: 'VR One Day Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/teen_patti_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901018',
    category: 'Virtual',
    gameCode: 'RG-29BC101-VR',
    gameName: 'VR 29 Card Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/29_card_baccarat_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901038',
    category: 'Virtual',
    gameCode: 'RG-12TP101-VR ',
    gameName: '2 card Teen Patti One day VR ',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/2_card_teen_patti_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901039',
    category: 'Virtual',
    gameCode: 'RG-1CC101-VR ',
    gameName: 'Center Card One day VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/center_card_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901041',
    category: 'Virtual',
    gameCode: 'RG-1MTP101-VR',
    gameName: 'Muflis TeenPatti One day VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/muflis_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901043',
    category: 'Virtual',
    gameCode: 'RG-1SPO101-VR',
    gameName: 'Super Over One day VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/super_over_one_day_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901045',
    category: 'Virtual',
    gameCode: 'RG-CC101-VR',
    gameName: 'Center Card VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/center_card_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901046',
    category: 'Virtual',
    gameCode: 'RG-HC101-VR',
    gameName: 'High Card VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/high_card_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901047',
    category: 'Virtual',
    gameCode: 'RG-QR101-VR',
    gameName: 'Queen Race VR',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/queen_race_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201161',
    category: 'Video Slots',
    gameCode: 'ont_texasholdem',
    gameName: 'Texas Holdem',
    urlThumb: 'https://cdn.dreamcasino.live/HoldEm_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201162',
    category: 'Video Slots',
    gameCode: 'ont_baccarat',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/Baccara_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201163',
    category: 'Video Slots',
    gameCode: 'ont_sicbo',
    gameName: 'Sic Bo',
    urlThumb: 'https://cdn.dreamcasino.live/SicBo_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201164',
    category: 'Video Slots',
    gameCode: 'ont_russianpoker',
    gameName: 'RussianPoker',
    urlThumb: 'https://cdn.dreamcasino.live/RussianPoker_BitCasino.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201165',
    category: 'Video Slots',
    gameCode: 'ont_blackjackclassic',
    gameName: 'Blackjack Classic',
    urlThumb: 'https://cdn.dreamcasino.live/BlackJack_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201166',
    category: 'Video Slots',
    gameCode: 'ont_baccaratnocommission',
    gameName: 'Baccarat No Commission',
    urlThumb: 'https://cdn.dreamcasino.live/NoComBaccara_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201167',
    category: 'Video Slots',
    gameCode: 'ont_blackjackclassicpp',
    gameName: 'Blackjack Classic PP',
    urlThumb: 'https://cdn.dreamcasino.live/BlackJackPP_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201168',
    category: 'Video Slots',
    gameCode: 'ont_roulette',
    gameName: 'Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/Roulette_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201169',
    category: 'Video Slots',
    gameCode: 'ont_inbetweenpoker',
    gameName: 'In Between Poker',
    urlThumb: 'https://cdn.dreamcasino.live/in-between-poker-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201170',
    category: 'Video Slots',
    gameCode: 'ont_andarbahar',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamcasino.live/Andar_Bahar_thumbnail_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201171',
    category: 'Video Slots',
    gameCode: 'ont_wheeloffortune',
    gameName: 'Wheel Of Fortune',
    urlThumb: 'https://cdn.dreamcasino.live/WOF_thumbnail_490x368.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201172',
    category: 'Video Slots',
    gameCode: 'ont_sumoshowdown-4reels',
    gameName: 'Sumo Showdown - 4 reels',
    urlThumb: 'https://cdn.dreamcasino.live/SumoShowdown-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201173',
    category: 'Video Slots',
    gameCode: 'ont_juicy7-3reels',
    gameName: 'Juicy7 - 3 reels',
    urlThumb: 'https://cdn.dreamcasino.live/Juicy7_thumbnail.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201174',
    category: 'Video Slots',
    gameCode: 'ont_highhandholdempoker',
    gameName: 'High Hand Holdem Poker',
    urlThumb: 'https://cdn.dreamcasino.live/HighHandHoldEm.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201176',
    category: 'Video Slots',
    gameCode: 'ont_goldenstripe',
    gameName: 'Golden Stripe',
    urlThumb: 'https://cdn.dreamcasino.live/goldenstripe-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201178',
    category: 'Video Slots',
    gameCode: 'ont_fortuneminer-3reels',
    gameName: 'Fortune Miner - 3 reels',
    urlThumb: 'https://cdn.dreamcasino.live/fortune-miner-thumb1.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201179',
    category: 'Video Slots',
    gameCode: 'ont_supremebaccarat',
    gameName: 'Baccarat Supreme',
    urlThumb: 'https://cdn.dreamcasino.live/baccarat-supreme-thumbnail2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201180',
    category: 'Live Baccarat',
    gameCode: 'ont_supremebaccaratnocommission',
    gameName: 'Baccarat Supreme No Commission',
    urlThumb: 'https://cdn.dreamcasino.live/NoComBaccara_regular.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201181',
    category: 'Video Slots',
    gameCode: 'ont_steamvault',
    gameName: 'Steam Vault',
    urlThumb: 'https://cdn.dreamcasino.live/steam-vault-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201182',
    category: 'Video Slots',
    gameCode: 'ont_wackywildlife',
    gameName: 'Wacky Wildlife',
    urlThumb: 'https://cdn.dreamcasino.live/wacky-wildlife-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201183',
    category: 'Video Slots',
    gameCode: 'ont_bubblesbonanza',
    gameName: 'Bubbles Bonanza',
    urlThumb: 'https://cdn.dreamcasino.live/ont_bubblesbonanza.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201184',
    category: 'Video Slots',
    gameCode: 'ont_dragontiger',
    gameName: 'Dragon Tiger',
    urlThumb: 'https://cdn.dreamcasino.live/ont_dragontiger.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201188',
    category: 'Video Slots',
    gameCode: 'ont_queensofglory',
    gameName: 'Queens of Glory',
    urlThumb: 'https://cdn.dreamcasino.live/ont_queensofglory.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201189',
    category: 'Video Slots',
    gameCode: 'ont_neon2077',
    gameName: 'Neon2077',
    urlThumb: 'https://cdn.dreamcasino.live/ont_neon2077.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201190',
    category: 'Video Slots',
    gameCode: 'ont_tikiterror',
    gameName: 'Tiki Terror',
    urlThumb: 'https://cdn.dreamcasino.live/ont_tikiterror-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201191',
    category: 'Video Slots',
    gameCode: 'ont_flexingdragons',
    gameName: 'Flexing Dragons',
    urlThumb: 'https://cdn.dreamcasino.live/ont_flexingdragons-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201192',
    category: 'Video Slots',
    gameCode: 'ont_wildwildwest2120',
    gameName: 'Wild Wild West 2120',
    urlThumb: 'https://cdn.dreamcasino.live/wild-wild-west-thumbnail.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201193',
    category: 'Video Slots',
    gameCode: 'ont_mvphoops',
    gameName: 'MVP Hoops',
    urlThumb: 'https://cdn.dreamcasino.live/ont_mvphoops-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201195',
    category: 'Video Slots',
    gameCode: 'ont_ganbarutobattle',
    gameName: 'GanBaruto Battle',
    urlThumb: 'https://cdn.dreamcasino.live/ganbaruto-battle-thumbnail.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201198',
    category: 'Video Slots',
    gameCode: 'ont_beatsex',
    gameName: 'Beats EX',
    urlThumb: 'https://cdn.dreamcasino.live/beatsfx-thumb.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201199',
    category: 'Video Slots',
    gameCode: 'ont_pipsquest',
    gameName: "Pip's Quest",
    urlThumb: 'https://cdn.dreamcasino.live/PipsQuest_Thumbnail.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201200',
    category: 'Video Slots',
    gameCode: 'ont_maidenandswordman',
    gameName: 'Maiden and Swordman',
    urlThumb:
      'https://cdn.dreamcasino.live/game-thumbs/latest/OT_TheMaidenAndTheSwordman_490x368.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201201',
    category: 'Video Slots',
    gameCode: 'ont_jewelrycats',
    gameName: 'Jewelry Cats',
    urlThumb: 'https://cdn.dreamcasino.live/ont_jewelrycats.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902001',
    category: 'Mini Games',
    gameCode: 'YG-7UP03-MINI',
    gameName: '7 Up & Down Mini ',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902002',
    category: 'Mini Games',
    gameCode: 'YG-DT103-MINI',
    gameName: 'Dragon Tiger Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902003',
    category: 'Mini Games',
    gameCode: 'YG-A3103-MINI',
    gameName: 'Amar Akbar Anthony Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902004',
    category: 'Mini Games',
    gameCode: 'YG-TP103-MINI',
    gameName: 'Teen Patti Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902005',
    category: 'Mini Games',
    gameCode: 'YG-HL103-MINI',
    gameName: 'Hi Low Mini ',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902006',
    category: 'Mini Games',
    gameCode: 'YG-CW103-MINI',
    gameName: 'Cricket War Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902007',
    category: 'Mini Games',
    gameCode: 'YG-MTP103-MINI',
    gameName: 'Teen Patti Muflis Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902008',
    category: 'Mini Games',
    gameCode: 'YG-2TP103-MINI',
    gameName: '2 card Teen Patti Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902010',
    category: 'Mini Games',
    gameCode: 'YG-DTL103-MINI',
    gameName: 'Dragon Tiger Lion Mini ',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902011',
    category: 'Mini Games',
    gameCode: 'YG-FBS103-MINI',
    gameName: 'Football Studio mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902012',
    category: 'Mini Games',
    gameCode: 'YG-LK7103-MINI',
    gameName: 'Lucky7  Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902013',
    category: 'Mini Games',
    gameCode: 'YG-ARW103-MINI',
    gameName: 'Akbar Romeo Walter Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902014',
    category: 'Mini Games',
    gameCode: 'YG-SPO103-MINI',
    gameName: 'Super Over Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902015',
    category: 'Mini Games',
    gameCode: 'YG-BAC103-MINI',
    gameName: 'Baccarat Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902016',
    category: 'Mini Games',
    gameCode: 'YG-POK103-MINI',
    gameName: 'Poker Mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '902017',
    category: 'Mini Games',
    gameCode: 'YG-AB103-MINI',
    gameName: 'Andar Bahar mini',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/yuvi.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Yuvi Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901124',
    category: 'Virtual',
    gameCode: 'RG-ITP2-VR',
    gameName: 'Instant Teenpatti 2 VR',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/instant_tp2_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901125',
    category: 'Virtual',
    gameCode: 'RG-ITP-VR',
    gameName: 'Instant Teenpatti VR',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/instant_tp1_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900080',
    category: 'Live',
    gameCode: 'RG-ITP2',
    gameName: 'Instant Teenpatti 2',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/itp2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900081',
    category: 'Live',
    gameCode: 'RG-ITP',
    gameName: 'Instant Teenpatti 1',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/itp1.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901076',
    category: 'Virtual',
    gameCode: 'RG_TTP101_VR',
    gameName: 'Test Teenpatti VR',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/testtp_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '903002',
    category: 'Live',
    gameCode: 'RG-XSB101',
    gameName: 'Sicbo Exclusive',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/sicbo_exclusive.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460001',
    category: 'Live',
    gameCode: 'bg_lucky7',
    gameName: 'Lucky 7',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/lucky7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460002',
    category: 'Live',
    gameCode: 'bg_lucky5',
    gameName: 'Lucky 5',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/lucky5.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460003',
    category: 'Live',
    gameCode: 'bg_bet_on_poker',
    gameName: 'Bet On Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/bet_on_poker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460004',
    category: 'Live',
    gameCode: 'bg_bet_on_baccarat',
    gameName: 'Bet On Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/bet_on_baccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460005',
    category: 'Live',
    gameCode: 'bg_wheel_of_fortune',
    gameName: 'Wheel Of Fortune',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/wheel_of_fortune.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460006',
    category: 'Live',
    gameCode: 'bg_war_of_bets',
    gameName: 'War Of Bets',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/war_of_bets.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460007',
    category: 'Live',
    gameCode: 'bg_lucky6',
    gameName: 'Lucky 6',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/lucky6.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460008',
    category: 'Live',
    gameCode: 'bg_dice_duel',
    gameName: 'Dice Duel',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/dice_duel.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460009',
    category: 'Live',
    gameCode: 'bg_speedy7',
    gameName: 'Speedy 7',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/speedy7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460010',
    category: 'Live',
    gameCode: 'bg_6_poker',
    gameName: '6+ Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/6poker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460011',
    category: 'Live',
    gameCode: 'bg_classic_wheel',
    gameName: 'Classic Wheel',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/classic_wheel.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460012',
    category: 'Live',
    gameCode: 'bg_football_grid',
    gameName: 'Football Grid',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/football_grid.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460013',
    category: 'Live',
    gameCode: 'bg_skyward',
    gameName: 'Skyward',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/skyward.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460014',
    category: 'Live',
    gameCode: 'bg_instant_lucky7',
    gameName: 'Instant Lucky 7',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/instant_lucky7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '460017',
    category: 'Live',
    gameCode: 'bg_classic_roulette',
    gameName: 'Classic Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/betgames/classic_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'BETGAMES',
    subProviderName: 'BetGames',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '903006',
    category: 'Live',
    gameCode: 'RG-XAB101',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamdelhi.com/rg/Andar_Bahar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225135',
    category: 'Video Slots',
    gameCode: 'big_bigbadbison',
    gameName: 'Big Bad Bison',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_bigbadbison.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225136',
    category: 'Video Slots',
    gameCode: 'big_bonanzafalls',
    gameName: 'Bonanza Falls',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_bonanzafalls.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225137',
    category: 'Video Slots',
    gameCode: 'big_christmascatch',
    gameName: 'Christmas Catch',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_christmascatch.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225138',
    category: 'Video Slots',
    gameCode: 'big_maxmegaways2',
    gameName: 'Max Megaways 2',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_maxmegaways2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225139',
    category: 'Video Slots',
    gameCode: 'big_moreturkey',
    gameName: 'More Turkey',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_moreturkey.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225140',
    category: 'Video Slots',
    gameCode: 'big_pandamoney',
    gameName: 'Panda Money',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_pandamoney.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225141',
    category: 'Video Slots',
    gameCode: 'big_sanctuary',
    gameName: 'Sanctuary',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_sanctuary.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225142',
    category: 'Video Slots',
    gameCode: 'big_vegasrush',
    gameName: 'Vegas Rush',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_vegasrush.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225143',
    category: 'Video Slots',
    gameCode: 'big_wildunicorns',
    gameName: 'Wild Unicorns',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_wildunicorns.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225752',
    category: 'Live Baccarat',
    gameCode: 'ont_baccarattripletreat',
    gameName: 'Baccarat Triple Treat',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/ont_baccarattripletreat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225755',
    category: 'Video Slots',
    gameCode: 'ont_geniessecretfeaturebuy-94rtp',
    gameName: "Genie's Secret Feature Buy",
    urlThumb: 'https://cdn.dreamdelhi.com/dc/ont_godhandfeaturebuy.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225758',
    category: 'Video Slots',
    gameCode: 'ont_giftsofhorus-94rtp',
    gameName: 'Gifts Of Horus',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/ont_mikofestivalfeaturebuy.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '225762',
    category: 'Video Slots',
    gameCode: 'ont_grandchristmasheistbuyfeature',
    gameName: 'Grand Christmas Heist Buy Feature',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/ont_wealthysharks.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226387',
    category: 'Crash Games',
    gameCode: 'sms_crash_duel_x',
    gameName: 'Crash Duel X',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/crash_duelx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226389',
    category: 'Video Slots',
    gameCode: 'sms_foxy_hot_20',
    gameName: 'Foxy Hot 20',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/foxy_20.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226399',
    category: 'Casual Games',
    gameCode: 'sms_mine_island',
    gameName: 'Mine Island',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/mine_island.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226406',
    category: 'Video Slots',
    gameCode: 'big_pandamoney94rtp',
    gameName: 'Panda Money',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/big_pandamoney.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226420',
    category: 'Crash Games',
    gameCode: 'sms_smash_x',
    gameName: 'Smash X',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/smashx.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '226440',
    category: 'Video Slots',
    gameCode: 'sms_wilds__gods',
    gameName: 'Wilds & Gods',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/wilds_gods.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230070',
    category: 'Slot games',
    gameCode: 'sms_book_of_futuria',
    gameName: 'Book of Futuria',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_book_of_futuria.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230071',
    category: 'Casual Games',
    gameCode: 'sms_roll_x',
    gameName: 'Roll X',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/sms_roll_x.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900047',
    category: 'TABLE',
    gameCode: 'RG-HC101',
    gameName: 'High Card',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/hc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900079',
    category: 'Live',
    gameCode: 'RG-TTP',
    gameName: 'Test Teenpatti',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/ttp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900082',
    category: 'TABLE',
    gameCode: 'RG-ROT-V2',
    gameName: 'Roulette Classic',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/roulette_classic.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900085',
    category: 'TABLE',
    gameCode: 'RG-ROT-V5',
    gameName: 'Diamond Roulette',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/diamond_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900086',
    category: 'TABLE',
    gameCode: 'RG-BAC-V2',
    gameName: 'Baccarat classic',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/baccarat_classic.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900087',
    category: 'TABLE',
    gameCode: 'RG-BAC-V3',
    gameName: 'Xclusive Baccarat ',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/xclusive_baccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900088',
    category: 'TABLE',
    gameCode: 'RG-TP-V3',
    gameName: 'VIP TeenPatti',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/vip_tp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900089',
    category: 'TABLE',
    gameCode: 'RG-TP-V2',
    gameName: 'Diamond Teen Patti',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/daimond_tp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '900090',
    category: 'Live',
    gameCode: 'RG-RTV2101',
    gameName: 'VIP Auto Roulette',
    urlThumb: 'https://rg-assests.royalgaming.online/lobby-icon/vip_ar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901128',
    category: 'Virtual',
    gameCode: 'RG-1NN101-VR',
    gameName: 'Note Number VR',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/note_number_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901130',
    category: 'Virtual',
    gameCode: 'RG-OCTT101-VR',
    gameName: 'One Card 20 20 VR',
    urlThumb:
      'https://rg-assests.royalgaming.online/lobby-icon/1card_2020_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425001',
    category: 'Table Game',
    gameCode: 'kingmidas_thai_hi_lo_2',
    gameName: 'Thai Hi Lo 2',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/thai_hi_lo_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425002',
    category: 'Table Game',
    gameCode: 'kingmidas_fish_prawn_crab_2',
    gameName: 'Fish Prawn Crab 2',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/fish_prawn_crab_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425003',
    category: 'Table Game',
    gameCode: 'kingmidas_belangkai_2',
    gameName: 'Belangkai 2',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/belangkai_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425004',
    category: 'Table Game',
    gameCode: 'kingmidas_dragon_tiger_2',
    gameName: 'Dragon Tiger 2',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/dragon_tiger_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425005',
    category: 'Table Game',
    gameCode: 'kingmidas_vietnam_fish_prawn_crab',
    gameName: 'Vietnam Fish Prawn Crab',
    urlThumb:
      'https://cdn.dreamdelhi.com/kingmidas/vietnam_fish_prawn_crab.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425006',
    category: 'Table Game',
    gameCode: 'kingmidas_sic_bo',
    gameName: 'Sic Bo',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/sic_bo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425007',
    category: 'Table Game',
    gameCode: 'kingmidas_tai_xiu',
    gameName: 'Tai Xiu',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/tai_xiu.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425008',
    category: 'Table Game',
    gameCode: 'kingmidas_max_keno',
    gameName: 'Max Keno',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/max_keno.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425009',
    category: 'Table Game',
    gameCode: 'kingmidas_poker_roulette',
    gameName: 'Poker Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/poker_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425010',
    category: 'Table Game',
    gameCode: 'kingmidas_thai_fish_prawn_crab',
    gameName: 'Thai Fish Prawn Crab',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/thai_fish_prawn_crab.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425011',
    category: 'Table Game',
    gameCode: 'kingmidas_xoc_dia_lightning',
    gameName: 'Xoc Dia Lightning',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/xoc_dia_lightning.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425012',
    category: 'Table Game',
    gameCode: 'kingmidas_fan_tan_classic',
    gameName: 'Fan Tan Classic',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/fan_tan_classic.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425013',
    category: 'Table Game',
    gameCode: 'kingmidas_triple_chance',
    gameName: 'Triple Chance',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/triple_chance.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425014',
    category: 'Table Game',
    gameCode: 'kingmidas_fruit_roulette',
    gameName: 'Fruit Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/fruit_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425015',
    category: 'Table Game',
    gameCode: 'kingmidas_bai_cao',
    gameName: 'Bai Cao',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/bai_cao.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425016',
    category: 'Table Game',
    gameCode: 'kingmidas_bai_buu',
    gameName: 'Bai Buu',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/bai_buu.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425017',
    category: 'Table Game',
    gameCode: 'kingmidas_european_roulette',
    gameName: 'European Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/european_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425018',
    category: 'Table Game',
    gameCode: 'kingmidas_7_up_7_down',
    gameName: '7 Up 7 Down',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/7_up_7_down.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425019',
    category: 'Table Game',
    gameCode: 'kingmidas_gao_gae',
    gameName: 'Gao Gae',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/gao_gae.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425020',
    category: 'Table Game',
    gameCode: 'kingmidas_jhandi_munda',
    gameName: 'Jhandi Munda',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/jhandi_munda.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425021',
    category: 'Table Game',
    gameCode: 'kingmidas_andar_bahar',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/andar_bahar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425022',
    category: 'Table Game',
    gameCode: 'kingmidas_baccarat',
    gameName: 'Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/baccarat.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425023',
    category: 'Table Game',
    gameCode: 'kingmidas_kingmaker_pok_deng',
    gameName: 'Kingmaker Pok Deng',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/kingmaker_pok_deng.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425024',
    category: 'Table Game',
    gameCode: 'kingmidas_bola_golek',
    gameName: 'Bola Golek',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/bola_golek.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425025',
    category: 'Table Game',
    gameCode: 'kingmidas_pai_kang',
    gameName: 'Pai Kang',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/pai_kang.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425026',
    category: 'Table Game',
    gameCode: 'kingmidas_coin_toss',
    gameName: 'Coin Toss',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/coin_toss.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425027',
    category: 'Table Game',
    gameCode: 'kingmidas_cards_hi_lo',
    gameName: 'Cards Hi Lo',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/cards_hi_lo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425028',
    category: 'Table Game',
    gameCode: 'kingmidas_blackjack',
    gameName: 'Blackjack',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/blackjack.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425029',
    category: 'Table Game',
    gameCode: 'kingmidas_32_cards',
    gameName: '32 Cards',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/32_cards.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425030',
    category: 'Table Game',
    gameCode: 'kingmidas_plinko',
    gameName: 'Plinko',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/plinko.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425031',
    category: 'Table Game',
    gameCode: 'kingmidas_cash_rocket',
    gameName: 'Cash Rocket',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/cash_rocket.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425032',
    category: 'Table Game',
    gameCode: 'kingmidas_bonus_dice',
    gameName: 'Bonus Dice',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/bonus_dice.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425033',
    category: 'Table Game',
    gameCode: 'kingmidas_minesweeper',
    gameName: 'Minesweeper',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/minesweeper.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425034',
    category: 'Table Game',
    gameCode: 'kingmidas_dota_hi-lo',
    gameName: 'Dota Hi-Lo',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/dota_hi-lo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425035',
    category: 'Table Game',
    gameCode: 'kingmidas_teen_patti',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425036',
    category: 'Table Game',
    gameCode: 'kingmidas_monkey_king_roulette',
    gameName: 'Monkey King Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/monkey_king_roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425037',
    category: 'Table Game',
    gameCode: 'kingmidas_heist',
    gameName: 'Heist',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/heist.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425038',
    category: 'Table Game',
    gameCode: 'kingmidas_5_card_poker',
    gameName: '5 Card Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/5_card_poker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425039',
    category: 'Table Game',
    gameCode: 'kingmidas_km_virtual_horse_racing',
    gameName: 'KM Virtual Horse Racing',
    urlThumb:
      'https://cdn.dreamdelhi.com/kingmidas/km_virtual_horse_racing.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425040',
    category: 'Table Game',
    gameCode: 'kingmidas_bola_tangkas',
    gameName: 'Bola Tangkas',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/bola_tangkas.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425041',
    category: 'Table Game',
    gameCode: 'kingmidas_color_game',
    gameName: 'Color Game',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/color_game.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425042',
    category: 'Table Game',
    gameCode: 'kingmidas_km_power_ball',
    gameName: 'KM Power Ball',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/km_power_ball.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425043',
    category: 'Table Game',
    gameCode: 'kingmidas_km_marble_knockout',
    gameName: 'KM Marble Knockout',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/km_marble_knockout.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425044',
    category: 'Table Game',
    gameCode: 'kingmidas_km_virtual_hound_racing',
    gameName: 'KM Virtual Hound Racing',
    urlThumb:
      'https://cdn.dreamdelhi.com/kingmidas/km_virtual_hound_racing.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425045',
    category: 'Slot Game',
    gameCode: 'kingmidas_sugar_blast',
    gameName: 'Sugar Blast',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/sugar_blast.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425046',
    category: 'Table Game',
    gameCode: 'kingmidas_km_virtual_treadmill_racing',
    gameName: 'KM Virtual Treadmill Racing',
    urlThumb:
      'https://cdn.dreamdelhi.com/kingmidas/km_virtual_treadmill_racing.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425047',
    category: 'Table Game',
    gameCode: 'kingmidas_ludo',
    gameName: 'Ludo',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/ludo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425048',
    category: 'Table Game',
    gameCode: 'kingmidas_km_virtual_animal_race',
    gameName: 'KM Virtual Animal Race',
    urlThumb:
      'https://cdn.dreamdelhi.com/kingmidas/km_virtual_animal_race.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425049',
    category: 'Table Game',
    gameCode: 'kingmidas_tongits',
    gameName: 'Tongits',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/tongits.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425050',
    category: 'Table Game',
    gameCode: 'kingmidas_pusoy',
    gameName: 'Pusoy',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/pusoy.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425051',
    category: 'Table Game',
    gameCode: 'kingmidas_cockfighting_arena',
    gameName: 'Cockfighting Arena',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/cockfighting_arena.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425052',
    category: 'Table Game',
    gameCode: 'kingmidas_coin_pusher',
    gameName: 'Coin Pusher',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/coin_pusher.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425053',
    category: 'Slot Game',
    gameCode: 'kingmidas_gems_of_valhalla',
    gameName: 'Gems of Valhalla',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/gems_of_valhalla.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425054',
    category: 'Slot Game',
    gameCode: 'kingmidas_sugar_blast_frenzy',
    gameName: 'Sugar Blast Frenzy',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/sugar_blast_frenzy.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425055',
    category: 'Slot Game',
    gameCode: "kingmidas_cleopatra's_treasure",
    gameName: "Cleopatra's Treasure",
    urlThumb: "https://cdn.dreamdelhi.com/kingmidas/cleopatra's_treasure.webp",
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425056',
    category: 'Slot Game',
    gameCode: 'kingmidas_rooster_blitz',
    gameName: 'Rooster Blitz',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/rooster_blitz.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425057',
    category: 'Table Game',
    gameCode: 'kingmidas_olympus_glory',
    gameName: 'Olympus Glory',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/olympus_glory.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425058',
    category: 'Table Game',
    gameCode: 'kingmidas_interstellar_run',
    gameName: 'Interstellar Run',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/interstellar_run.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425059',
    category: 'Table Game',
    gameCode: 'kingmidas_elite_aviator_club',
    gameName: 'Elite Aviator Club',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/elite_aviator_club.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425060',
    category: 'Table Game',
    gameCode: 'kingmidas_jackpot_jump',
    gameName: 'Jackpot Jump',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/jackpot_jump.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425061',
    category: 'Table Game',
    gameCode: 'kingmidas_penguin_panic',
    gameName: 'Penguin Panic',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/penguin_panic.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425062',
    category: 'Table Game',
    gameCode: 'kingmidas_video_poker',
    gameName: 'Video Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/video_poker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425063',
    category: 'Table Game',
    gameCode: 'kingmidas_gold_mine',
    gameName: 'Gold Mine',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/gold_mine.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425064',
    category: 'Table Game',
    gameCode: 'kingmidas_toon_crash',
    gameName: 'Toon Crash',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/toon_crash.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '425065',
    category: 'Table Game',
    gameCode: 'kingmidas_iron_dome',
    gameName: 'Iron Dome',
    urlThumb: 'https://cdn.dreamdelhi.com/kingmidas/iron_dome.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'KINGMIDAS',
    subProviderName: 'KINGMAKER',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230338',
    category: 'Video Slots',
    gameCode: 'sms_hot_samba',
    gameName: 'Hot Samba',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_hot_samba.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230339',
    category: 'Video Slots',
    gameCode: 'sms_wild_multi_stars',
    gameName: 'Wild Multi Stars',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_wild_multi_stars.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230351',
    category: 'Video Slots',
    gameCode: 'sms_safari_simba',
    gameName: 'Safari Simba',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_safari_simba.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230352',
    category: 'Video Slots',
    gameCode: 'sms_sugar_fiesta',
    gameName: 'Sugar Fiesta',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_sugar_fiesta.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230396',
    category: 'Video Slots',
    gameCode: 'sms_draculas_fortune',
    gameName: 'Dracula’s Fortune',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_draculas_fortune.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230407',
    category: 'Video Slots',
    gameCode: 'sms_samba_da_deusa',
    gameName: 'Samba Da Deusa',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_samba_da_deusa.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230411',
    category: 'Video Slots',
    gameCode: 'sms_book_of_bonanza',
    gameName: 'Book of Bonanza',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_book_of_bonanza.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230412',
    category: 'Casual Games',
    gameCode: 'sms_plinko_joker',
    gameName: '4 Bonuses Bonanza',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/sms_plinko_joker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Smartsoft Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230568',
    category: 'Video Slots',
    gameCode: 'big_thefinalcountdown',
    gameName: 'The Final Countdown',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_thefinalcountdown.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230569',
    category: 'Video Slots',
    gameCode: 'big_millionairemysterybox',
    gameName: 'Millionaire Mystery Box',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_millionairemysterybox.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230571',
    category: 'Video Slots',
    gameCode: 'big_bookofgods',
    gameName: 'Book of Gods',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_bookofgods.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230579',
    category: 'Video Slots',
    gameCode: 'big_kingofcats',
    gameName: 'King of Cats',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_kingofcats.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230582',
    category: 'Video Slots',
    gameCode: 'big_chocolates',
    gameName: 'Chocolates',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_chocolates.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230584',
    category: 'Video Slots',
    gameCode: 'big_luckystreakmk2',
    gameName: 'Lucky Streak Mk2',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_luckystreakmk2.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230585',
    category: 'Video Slots',
    gameCode: 'big_cyberslotmegaclusters',
    gameName: 'Cyberslot Megaclusters',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_cyberslotmegaclusters.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230586',
    category: 'Video Slots',
    gameCode: 'big_queenofriches',
    gameName: 'Queen of Riches',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_queenofriches.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230632',
    category: 'Video Slots',
    gameCode: 'big_spicymeatballs',
    gameName: 'Spicy Meatballs',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_spicymeatballs.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230664',
    category: 'Video Slots',
    gameCode: 'ont_infinitytower',
    gameName: 'Infinity Tower',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_infinitytower.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230665',
    category: 'Video Slots',
    gameCode: 'ont_godhand',
    gameName: 'God Hand',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_godhand.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230674',
    category: 'Video Slots',
    gameCode: 'ont_firecombo',
    gameName: 'Fire Combo',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_firecombo.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230690',
    category: 'Other Table Games',
    gameCode: 'ont_teenpatti20-20',
    gameName: 'Teen Patti 20-20',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_teenpatti20-20.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230691',
    category: 'Video Slots',
    gameCode: 'ont_grandheist',
    gameName: 'Grand Heist',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_grandheist.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230708',
    category: 'Video Slots',
    gameCode: 'ont_seatreasure',
    gameName: 'Sea Treasure',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_seatreasure.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230709',
    category: 'Bingo',
    gameCode: 'ont_kenorush',
    gameName: 'Keno Rush',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_kenorush.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230710',
    category: 'Video Slots',
    gameCode: 'ont_snackblast',
    gameName: 'Snack Blast',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_snackblast.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230711',
    category: 'Video Slots',
    gameCode: 'ont_stonegaze',
    gameName: 'Stone Gaze',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_stonegaze.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230712',
    category: 'Video Slots',
    gameCode: 'ont_geniessecret',
    gameName: "Genie's Secret",
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_geniessecret.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230756',
    category: 'Other Table Games',
    gameCode: 'ont_teenpatti',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_teenpatti.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230785',
    category: 'Blackjack',
    gameCode: 'ont_blackjacksuprememhpp',
    gameName: 'Blackjack Supreme MHPP',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_blackjacksuprememhpp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230786',
    category: 'Video Slots',
    gameCode: 'ont_travelingtreasuresafrica',
    gameName: 'Traveling Treasures Africa',
    urlThumb:
      'https://cdn.dreamdelhi.com/dream/ont_travelingtreasuresafrica.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230807',
    category: 'Video Slots',
    gameCode: 'ont_bonustrack',
    gameName: 'Bonus Track',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_bonustrack.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230814',
    category: 'Video Slots',
    gameCode: 'ont_goldenshisa',
    gameName: 'Golden Shisa',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_goldenshisa.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230824',
    category: 'Video Slots',
    gameCode: 'ont_queensofglorylegacy',
    gameName: 'Queens of Glory Legacy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_queensofglorylegacy.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230825',
    category: 'Video Slots',
    gameCode: 'ont_raidenmedalburst',
    gameName: 'Raiden Medal Burst',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_raidenmedalburst.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230871',
    category: 'Video Slots',
    gameCode: 'big_wildportals',
    gameName: 'Wild Portals',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_wildportals.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230902',
    category: 'Video Slots',
    gameCode: 'ont_grandheistfeaturebuy',
    gameName: 'Grand Heist Feature Buy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_grandheistfeaturebuy.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230903',
    category: 'Video Slots',
    gameCode: 'ont_mikofestival',
    gameName: 'Miko Festival',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_mikofestival.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230904',
    category: 'Crash Games',
    gameCode: 'ont_cashgalaxy',
    gameName: 'Cash Galaxy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_cashgalaxy.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230916',
    category: 'Video Slots',
    gameCode: 'ont_ladyfortunaa',
    gameName: 'Lady Fortuna',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ladyfortunaa.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230926',
    category: 'Video Slots',
    gameCode: 'big_vegasmegaways',
    gameName: 'Vegas Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_vegasmegaways.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230927',
    category: 'Video Slots',
    gameCode: 'ont_ladyfortuna94rtp',
    gameName: 'Lady Fortuna',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ladyfortuna94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230933',
    category: 'Video Slots',
    gameCode: 'ont_grandheist-94rtp',
    gameName: 'Grand Heist',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_grandheist-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230934',
    category: 'Video Slots',
    gameCode: 'ont_godhand-94rtp',
    gameName: 'God Hand',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_godhand-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230935',
    category: 'Video Slots',
    gameCode: 'ont_pipsquest-94rtp',
    gameName: "Pip's Quest",
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_pipsquest-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230936',
    category: 'Video Slots',
    gameCode: 'ont_snackblast-94rtp',
    gameName: 'Snack Blast',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_snackblast-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230937',
    category: 'Video Slots',
    gameCode: 'ont_wildwildwest2120-94rtp',
    gameName: 'Wild Wild West 2120',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_wildwildwest2120-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230938',
    category: 'Video Slots',
    gameCode: 'ont_ganbarutobattle-94rtp',
    gameName: 'Gan Baruto Battle',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ganbarutobattle-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230947',
    category: 'Video Slots',
    gameCode: 'big_maxmegaways',
    gameName: 'Max Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_maxmegaways.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230958',
    category: 'Video Slots',
    gameCode: 'ont_mikofestival-94rtp',
    gameName: 'Miko Festival',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_mikofestival-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230959',
    category: 'Video Slots',
    gameCode: 'ont_mikofestival-92rtp',
    gameName: 'Miko Festival',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_mikofestival-92rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230982',
    category: 'Video Slots',
    gameCode: 'big_castleofterror',
    gameName: 'Castle Of Terror',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_castleofterror.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230997',
    category: 'Video Slots',
    gameCode: 'ont_grandheistfeaturebuy-94rtp',
    gameName: 'Grand Heist Feature Buy',
    urlThumb:
      'https://cdn.dreamdelhi.com/dream/ont_grandheistfeaturebuy-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231010',
    category: 'Video Slots',
    gameCode: 'ont_ryseofrome',
    gameName: 'Ryse of Rome',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ryseofrome.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231070',
    category: 'Video Slots',
    gameCode: 'big_outlaw',
    gameName: 'Outlaw',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_outlaw.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231073',
    category: 'Video Slots',
    gameCode: 'ont_ryseofrome94',
    gameName: 'Ryse of Rome',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ryseofrome94.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231088',
    category: 'Video Slots',
    gameCode: 'ont_reelfruitzfrenzy',
    gameName: 'Reel Fruitz Frenzy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_reelfruitzfrenzy.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231090',
    category: 'Video Slots',
    gameCode: 'big_christmasbonanza',
    gameName: 'Christmas Bonanza',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_christmasbonanza.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231112',
    category: 'Video Slots',
    gameCode: 'big_rasputinmegaways',
    gameName: 'Rasputin Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_rasputinmegaways.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231137',
    category: 'Roulette',
    gameCode: 'ont_bombayroulette',
    gameName: 'Bombay Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_bombayroulette.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231138',
    category: 'Video Slots',
    gameCode: 'big_giftsoffortune',
    gameName: 'Gifts of Fortune',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_giftsoffortune.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231171',
    category: 'Video Slots',
    gameCode: 'ont_reelfruitzfrenzy94',
    gameName: 'Reel Fruitz Frenzy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_reelfruitzfrenzy94.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231217',
    category: 'Video Slots',
    gameCode: 'ont_wildcoyotemegaways',
    gameName: 'Wild Coyote Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_wildcoyotemegaways.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231224',
    category: 'Video Slots',
    gameCode: 'ont_seatreasuredeepdive',
    gameName: 'Sea Treasure Deep Dive',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_seatreasuredeepdive.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231263',
    category: 'Video Slots',
    gameCode: 'big_therace',
    gameName: 'The Race',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_therace.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231264',
    category: 'Video Slots',
    gameCode: 'ont_jewelrycats-94rtp',
    gameName: 'Jewelry Cats',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_jewelrycats-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231265',
    category: 'Video Slots',
    gameCode: 'ont_travelingtreasuresafrica-94rtp',
    gameName: 'Traveling Treasures Africa',
    urlThumb:
      'https://cdn.dreamdelhi.com/dream/ont_travelingtreasuresafrica-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231266',
    category: 'Video Slots',
    gameCode: 'ont_raidenmedalburst-94rtp',
    gameName: 'Raiden Medal Burst',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_raidenmedalburst-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231267',
    category: 'Video Slots',
    gameCode: 'ont_wildcoyotemegaways94rtp',
    gameName: 'Wild Coyote Megaways',
    urlThumb:
      'https://cdn.dreamdelhi.com/dream/ont_wildcoyotemegaways94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231268',
    category: 'Video Slots',
    gameCode: 'ont_seatreasure-94rtp',
    gameName: 'Sea Treasure',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_seatreasure-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231269',
    category: 'Video Slots',
    gameCode: 'ont_infinitytower-94rtp',
    gameName: 'Infinity Tower',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_infinitytower-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231270',
    category: 'Video Slots',
    gameCode: 'ont_stonegaze-94rtp',
    gameName: 'Stone Gaze',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_stonegaze-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231271',
    category: 'Video Slots',
    gameCode: 'ont_geniessecret-94rtp',
    gameName: "Genie's Secret",
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_geniessecret-94rtp.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231275',
    category: 'Blackjack',
    gameCode: 'ont_bombayblackjack',
    gameName: 'Bombay Blackjack',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_bombayblackjack.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231279',
    category: 'Video Slots',
    gameCode: 'ont_geniessecretfeaturebuy',
    gameName: "Genie's Secret Feature Buy",
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_geniessecretfeaturebuy.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231284',
    category: 'Video Slots',
    gameCode: 'big_overthemoon',
    gameName: 'Over The Moon',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_overthemoon.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231328',
    category: 'Video Slots',
    gameCode: 'ont_ryseofthemightygods',
    gameName: 'Ryse of the Mighty Gods',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_ryseofthemightygods.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231574',
    category: 'Video Slots',
    gameCode: 'big_fireworksmegaways',
    gameName: 'Fireworks Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_fireworksmegaways.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231612',
    category: 'Baccarat',
    gameCode: 'ont_minibaccarat',
    gameName: 'Mini Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_minibaccarat.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231712',
    category: 'Roulette',
    gameCode: 'ont_miniroulette',
    gameName: 'Mini Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_miniroulette.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231833',
    category: 'Blackjack',
    gameCode: 'ont_miniblackjack',
    gameName: 'Mini Blackjack',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_miniblackjack.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231944',
    category: 'Hi Lo',
    gameCode: 'ont_minihilo',
    gameName: 'Mini HiLo',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_minihilo.png',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '231994',
    category: 'Crash',
    gameCode: 'ont_miniplinko',
    gameName: 'Mini Plinko',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_miniplinko.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232131',
    category: 'Video Slots',
    gameCode: 'big_triggerhappy',
    gameName: 'Trigger Happy',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_triggerhappy.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232138',
    category: 'Video Slots',
    gameCode: 'big_royalmint94rtp',
    gameName: 'Royal Mint',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_royalmint94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232142',
    category: 'Video Slots',
    gameCode: 'ont_legendscup',
    gameName: 'Legends Cup',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_legendscup.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232164',
    category: 'Video Slots',
    gameCode: 'ont_legendscup-94rtp',
    gameName: 'Legends Cup',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_legendscup-94rtp.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232209',
    category: 'Video Slots',
    gameCode: 'big_fizzypennyslot',
    gameName: 'Fizzy Pennyslot',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_fizzypennyslot.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232225',
    category: 'Video Slots',
    gameCode: 'ont_pawsomeplinko',
    gameName: 'Pawsome Plinko',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/ont_pawsomeplinko.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'OneTouch',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232432',
    category: 'Video Slots',
    gameCode: 'big_boo',
    gameName: 'Boo',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_boo.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232455',
    category: 'Video Slots',
    gameCode: 'big_holydivermegaways',
    gameName: 'Holy Diver Megaways',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_holydivermegaways.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '232585',
    category: 'Video Slots',
    gameCode: 'big_dangerhighvoltage2',
    gameName: 'Danger High Voltage 2',
    urlThumb: 'https://cdn.dreamdelhi.com/dream/big_dangerhighvoltage2.jpg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150001',
    category: 'Live',
    gameCode: 'MAC88-YDT102',
    gameName: 'Dragon Tiger',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/dt_mac88.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150002',
    category: 'Live',
    gameCode: 'MAC88-XBAC101',
    gameName: 'Bacarrat',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/baccarat_mac88.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150003',
    category: 'Live',
    gameCode: 'MAC88-XSB101',
    gameName: 'Sic Bo',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/sicbo_mac88.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150004',
    category: 'Live',
    gameCode: 'MAC88-XRT101',
    gameName: 'Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/roulette_mac88.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150005',
    category: 'Live',
    gameCode: 'MAC88-XPOK101',
    gameName: 'Poker 20-20',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/20_20_poker.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150006',
    category: 'Live',
    gameCode: 'MAC88-YLK7101',
    gameName: 'Lucky7',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/lucky_7.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150007',
    category: 'Live',
    gameCode: 'MAC88-XAB101',
    gameName: 'Andar Bahar',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/andar_bahar.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150009',
    category: 'Live',
    gameCode: 'MAC88-X1TP101',
    gameName: 'Teenpatti One Day',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/tp1d.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150010',
    category: 'Live',
    gameCode: 'MAC88-Y32CA102',
    gameName: '32 Cards',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/32_cards.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150013',
    category: 'Live',
    gameCode: 'MAC88-YDTL101',
    gameName: 'DTL',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/dtl_20_20.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150014',
    category: 'Live',
    gameCode: 'MAC88-YA3101',
    gameName: 'Amar Akbar Anthony',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/amar_akbar_anthony.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150015',
    category: 'Live',
    gameCode: 'MAC88-X3CJ101',
    gameName: '3 Cards Judgement',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/3cj.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150016',
    category: 'Live',
    gameCode: 'MAC88-YQR102',
    gameName: 'Queen Race',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/queen.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150017',
    category: 'Live',
    gameCode: 'MAC88-YRTT102',
    gameName: 'Race 20',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/race_20.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150018',
    category: 'Live',
    gameCode: 'MAC88-XCAW101',
    gameName: 'Casino War',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/casino_war.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150019',
    category: 'Live',
    gameCode: 'MAC88-YWM102',
    gameName: 'Worli Matka',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/worli_matka.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150020',
    category: 'Live',
    gameCode: 'MAC88-XLOT101',
    gameName: 'Lottery',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/lottery.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150023',
    category: 'Live',
    gameCode: 'MAC88-YTTP102',
    gameName: 'Test Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/teenpatti_test.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150024',
    category: 'Live',
    gameCode: 'MAC88-XTRP101',
    gameName: 'The Trap',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/trap.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150025',
    category: 'Live',
    gameCode: 'MAC88-XTRI101',
    gameName: 'Trio',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/trio.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150026',
    category: 'Live',
    gameCode: 'MAC88-X29BC101',
    gameName: '29 Baccarat',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/29b.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150028',
    category: 'Live',
    gameCode: 'MAC88-Y12TP101',
    gameName: 'Two Card Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/2_cards_teenpatti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150030',
    category: 'Live',
    gameCode: 'MAC88-Y1MTP101',
    gameName: 'Muflis Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/muflis_teenpati.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150031',
    category: 'Live',
    gameCode: 'MAC88-YBOC102',
    gameName: 'Bollywood Casino B',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/bollywood_casino.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150032',
    category: 'Live',
    gameCode: 'MAC88-Y1POK101',
    gameName: 'Poker 1-Day',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/poker_1_day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150033',
    category: 'Live',
    gameCode: 'MAC88-YTPTT101',
    gameName: '20-20 Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/20_20_teenpatti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150034',
    category: 'Live',
    gameCode: 'MAC88-Y1SPO101',
    gameName: 'Super Over',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/super_over.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150035',
    category: 'Live',
    gameCode: 'MAC88-Y15C101',
    gameName: '5 Five Cricket',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/5_five_cricket.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150036',
    category: 'Live',
    gameCode: 'MAC88-X1DT101',
    gameName: '1 Day Dragon Tiger',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/dt_1day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150037',
    category: 'Live',
    gameCode: 'MAC88-X1DKD101',
    gameName: 'Dus Ka Dum',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/10kadum.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150038',
    category: 'Live',
    gameCode: 'MAC88-XCTT101',
    gameName: 'One Card 20 20',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/1_card_20_20.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150039',
    category: 'Live',
    gameCode: 'MAC88-XOCM101',
    gameName: 'One Card Meter',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/1_card_meter.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150040',
    category: 'Live',
    gameCode: 'MAC88-X10C101',
    gameName: 'One Card One Day',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/1c1d.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150041',
    category: 'Poker',
    gameCode: 'MAC88-X6PP101',
    gameName: '6 Player Poker',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/6pp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150042',
    category: 'Live',
    gameCode: 'MAC88-X2TP101',
    gameName: 'Instant 2 Cards Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/2_card_tp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150043',
    category: 'Live',
    gameCode: 'MAC88-XRT17101',
    gameName: 'Race to 17',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/race_17.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150045',
    category: 'Live',
    gameCode: 'MAC88-X1NN101',
    gameName: 'Note Number',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/notenumber.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150046',
    category: 'Live',
    gameCode: 'MAC88-XCM101',
    gameName: 'Cricket Match 20-20',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/cricket2020.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150048',
    category: 'Live',
    gameCode: 'MAC88-X1RTS101',
    gameName: 'Race to 2nd',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/race_2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150049',
    category: 'Live',
    gameCode: 'MAC88-YOTP101',
    gameName: 'Open Teen patti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/open_teen_patti.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150050',
    category: 'Live',
    gameCode: 'MAC88-Y1CC101',
    gameName: 'Center Card One Day',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/center_card_one_day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150051',
    category: 'Live',
    gameCode: 'MAC88-YHL101',
    gameName: 'High Low',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/high_low.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150052',
    category: 'Live',
    gameCode: 'MAC88-Y1BAC101',
    gameName: 'Baccarat One Day',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/baccarat_one_day.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150053',
    category: 'Live',
    gameCode: 'MAC88-YXC101',
    gameName: '10 - 10 cricket ',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/10_10_cricket.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150054',
    category: 'Live',
    gameCode: 'MAC88-ZMTP101',
    gameName: 'Muflis Teenpatti',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/mtp.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150055',
    category: 'Live',
    gameCode: 'MAC88-ZIW101',
    gameName: 'Instant worli',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/iw.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150058',
    category: 'Live',
    gameCode: 'MAC88-ZSP101',
    gameName: 'Super Over',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/so.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150059',
    category: 'Live',
    gameCode: 'MAC88-ZCC101',
    gameName: 'Center card',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/cc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150061',
    category: 'Live',
    gameCode: 'MAC88-ZSBC101',
    gameName: 'Side Bet city',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/sbc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150066',
    category: 'Live',
    gameCode: 'MAC88-TPTT2101',
    gameName: '20 20 Teenpatti 2',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/2020tp2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '150067',
    category: 'Live',
    gameCode: 'MAC88-DT2101',
    gameName: 'Dragon Tiger 2',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/dt2.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '151005',
    category: 'Virtual',
    gameCode: 'MAC88-VTGDTL101',
    gameName: 'VR 20-20 DTL',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/vr_2020_dtl.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '151026',
    category: 'Live',
    gameCode: 'MAC88-VTGLN101',
    gameName: 'Lankesh',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/lankesh.jpeg',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '151069',
    category: 'Virtual',
    gameCode: 'MAC88-CC101',
    gameName: 'Center Card VR',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/vr_cc.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '151070',
    category: 'Virtual',
    gameCode: 'MAC88-KBC101',
    gameName: 'Kaun Banega Crorepati VR',
    urlThumb: 'https://cdn.dreamdelhi.com/mac88/kbc_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'MAC88',
    subProviderName: 'Mac88 Gaming Virtual',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230005',
    category: 'Slot',
    gameCode: 'monk88_mines',
    gameName: 'Mines',
    urlThumb: 'https://cdn.dreamdelhi.com/monk88/mines.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Monk88',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230007',
    category: 'Slot',
    gameCode: 'monk88_slide',
    gameName: 'X-Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/monk88/roulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Monk88',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '230008',
    category: 'Slot',
    gameCode: 'monk88_hilo',
    gameName: 'Hilo',
    urlThumb: 'https://cdn.dreamdelhi.com/monk88/hilo.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Monk88',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '289999',
    category: 'Crash Games',
    gameCode: 'monk88_pushparani',
    gameName: 'Pushpa Rani',
    urlThumb: 'https://cdn.dreamdelhi.com/monk88/pushparani.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Monk88',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201395',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat R',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_speedbaccaratr.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201396',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat S',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_speedbaccarats.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201397',
    category: 'Live Crash',
    gameCode: '',
    gameName: 'Cash or Crash',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_cashorcrash.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201398',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat E',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_salonprivebaccarate.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201399',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Golden Wealth Baccarat',
    urlThumb:
      'https://cdn.dreamcasino.live/Evolution/evo_goldenwealthbaccarat.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/evo_goldenwealthbaccarat_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201400',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'First Person Golden Wealth Baccarat',
    urlThumb:
      'https://cdn.dreamcasino.live/Evolution/evo_firstpersongoldenwealthbaccarat.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/evo_goldenwealthbaccarat_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201401',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'First Person Lightning Baccarat',
    urlThumb:
      'https://cdn.dreamcasino.live/Evolution/evo_firstpersonlightningbaccarat.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/evo_firstpersonlightningbaccarat_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201402',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Lightning Blackjack',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_lightningblackjack.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201403',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'First Person Lightning Blackjack',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_fplightningblackjack.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201404',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Emperor Speed Baccarat A',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_emperorspeedbaccarata.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_emperorspeedbaccarata.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201405',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Emperor Speed Baccarat B',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_emperorspeedbaccaratb.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_emperorspeedbaccaratb.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201406',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Emperor Dragon Tiger ',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_emperordragontiger.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_emperordragontiger.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201407',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Lotus Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_lotusroulette.webp',
    urlBackground: 'https://cdn.hub88.io/evolution/bg/evo_lotusroulette.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201408',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Lotus Speed Baccarat A',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_lotusspeedbaccarata.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_lotusspeedbaccarata.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201409',
    category: 'Unknown',
    gameCode: '',
    gameName: 'Bac Bo',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_bacbo.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201410',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'Emperor Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_emperorroulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201411',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Emperor Speed Baccarat C',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_emperorspeedbaccaratc.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201412',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 17',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip17.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201413',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 18',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip18.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201414',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 19',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip19.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201415',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Peek Baccarat',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_peekbaccarat.webp',
    urlBackground: 'https://cdn.hub88.io/evolution/bg/evo_peekbaccarat.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201416',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 20',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip20.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201417',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 21',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip21.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201418',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Blackjack VIP 22',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_blackjackvip22.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201419',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed VIP Blackjack I',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_speedvipblackjacki.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201420',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed VIP Blackjack J',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_speedvipblackjackj.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201421',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Speed VIP Blackjack H',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_speedvipblackjackh.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201422',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat F',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_salonprivebaccaratf.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201423',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Salon Prive Baccarat G',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_salonprivebaccaratg.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_salonprivebaccaratg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201424',
    category: 'Live Blackjack',
    gameCode: '',
    gameName: 'Salon Prive Blackjack G',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_salonpriveblackjackg.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_salonpriveblackjackg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201425',
    category: 'Live Dice',
    gameCode: '',
    gameName: 'Emperor Sic Bo',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_emperorsicbo.webp',
    urlBackground: 'https://cdn.hub88.io/evolution/bg/evo_emperorsicbo.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201426',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Super Andar Bahar',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_superandarbahar.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201427',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Hindi Lobby',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_hindilobby.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201428',
    category: 'Live Roulette',
    gameCode: '',
    gameName: 'XXXTreme Lightning Roulette',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_xxxtremelightningroulette.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_xxxtremelightningroulette.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201429',
    category: 'Live Games',
    gameCode: '',
    gameName: 'First Person Deal or no Deal',
    urlThumb:
      'https://cdn.dreamcasino.live/evolution/evo_firstpersondealornodeal.webp',
    urlBackground:
      'https://cdn.hub88.io/evolution/bg/evo_firstpersondealornodeal.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201430',
    category: 'Live Games',
    gameCode: '',
    gameName: 'Crazy Coin Flip',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_crazycoinflip.webp',
    urlBackground: 'https://cdn.hub88.io/evolution/bg/evo_crazycoinflip.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201431',
    category: 'Live Dealer',
    gameCode: '',
    gameName: 'Teen Patti',
    urlThumb: 'https://cdn.dreamcasino.live/evolution/evo_teenpatti.webp',
    urlBackground: 'https://cdn.hub88.io/evolution/bg/evo_teenpatti.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201432',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat T',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_speedbaccaratt.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201433',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat U',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_speedbaccaratu.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201434',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat V',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_speedbaccaratv.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201435',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat W',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_speedbaccaratw.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201436',
    category: 'Live Baccarat',
    gameCode: '',
    gameName: 'Speed Baccarat X',
    urlThumb: 'https://cdn.dreamcasino.live/Evolution/evo_speedbaccaratx.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201550',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Danger High Voltage',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_dangerhighvoltage.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201552',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Bonanza',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_bonanza.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_bonanza.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201553',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Opal Fruits',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_opalfruits.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_opalfruits.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201555',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'White Rabbit',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_whiterabbit.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_whiterabbit.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201556',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Kingmaker',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_kingmaker.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_kingmaker.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201557',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Millionaire',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_millionaire.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_millionaire.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201558',
    category: 'Video Slots',
    gameCode: '',
    gameName: "Lil' Devil",
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_lildevil.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_lildevil.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201561',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Donuts',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_donuts.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_donuts.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201562',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Royal Mint',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_royalmint.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_royalmint.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201565',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Star Clusters',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_starclusters.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_starclusters.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201568',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Slot Vegas',
    urlThumb: 'https://cdn.dreamcasino.live/btg/slot-vegas-thumbnail.webp',
    urlBackground: 'https://cdn.hub88.io/btg/slot-vegas-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201574',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Pop',
    urlThumb: 'https://cdn.dreamcasino.live/btg/pop-thumb.webp',
    urlBackground: 'https://cdn.hub88.io/btg/pop-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201575',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Beef Lightning',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_beeflightning.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_beeflightning.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201576',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Wild Flower',
    urlThumb: 'https://cdn.dreamcasino.live/btg/wild-flower-thumbnail.webp',
    urlBackground: 'https://cdn.hub88.io/btg/wild-flower-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201579',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Pirate Pays',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_piratepays.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_piratepays.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201580',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Gold Megaways',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_goldmegaways.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_goldmegaways.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201581',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Apollo Pays',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_apollopays.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_apollopays.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201582',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Diamond Fruits',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_diamondfruits.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_diamondfruits.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201583',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Golden Catch',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_goldencatch.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_goldencatch.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201584',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Millionaire Rush',
    urlThumb: 'https://cdn.dreamcasino.live/btg/big_millionairerush.webp',
    urlBackground: 'https://cdn.hub88.io/btg/bg/big_millionairerush.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Big Time Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201707',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Flaming Chilies',
    urlThumb: 'https://cdn.dreamcasino.live/booming/bmg_flamingchilies.webp',
    urlBackground: 'https://cdn.hub88.io/booming/bg/bmg_flamingchilies.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Booming Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201711',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Gamblelicious Hold and Win ',
    urlThumb:
      'https://cdn.dreamcasino.live/booming/bmg_gambleliciousholdandwn.webp',
    urlBackground:
      'https://cdn.hub88.io/booming/bg/bmg_gambleliciousholdandwn.png',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Booming Games',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201776',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Heroes Hunt 2 Christmas Edition',
    urlThumb:
      'https://cdn.dreamcasino.live/fantasma/fan_heroeshunt2christmas.webp',
    urlBackground: 'https://cdn.hub88.io/fantasma/bg/fan_heroeshunt2.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Fantasma',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201782',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Golden Castle',
    urlThumb:
      'https://cdn.dreamcasino.live/relaxgaming/golden-castle-thumbnail.webp',
    urlBackground: 'https://cdn.hub88.io/relaxgaming/golden-castle-bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Fantasma',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201783',
    category: 'Video Slots',
    gameCode: '',
    gameName: 'Heroes Hunt',
    urlThumb:
      'https://cdn.dreamcasino.live/relaxgaming/fan_heroeshunt_thumbnail.webp',
    urlBackground: 'https://cdn.hub88.io/relaxgaming/fan_heroeshunt_bg.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Fantasma',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201825',
    category: 'Video Slots',
    gameCode: '',
    gameName: "Fat Mama's Wheel",
    urlThumb: 'https://cdn.dreamcasino.live/fugaso/fgsz_fatmamaswheel.webp',
    urlBackground: 'https://cdn.hub88.io/fugaso/bg/fgsz_fatmamaswheel.jpg',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Fugaso',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '201826',
    category: 'Crash',
    gameCode: '',
    gameName: 'Magnify Man',
    urlThumb: 'https://cdn.dreamcasino.live/fugaso/fgsz_magnifyman.webp',
    urlBackground: 'https://cdn.hub88.io/fugaso/bg/fgsz_magnifyman.png',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Fugaso',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204081',
    category: 'Live Game Shows',
    gameCode: 'evo_monopoly_big_baller',
    gameName: 'Monopoly Big Baller',
    urlThumb:
      'https://cdn.dreamdelhi.com/dc/monopoly_big_baller_thumbnail.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '204099',
    category: 'Live Roulette',
    gameCode: 'evo_xxxtreme_lightning_roulette',
    gameName: 'XXXtreme Lightning Roulette',
    urlThumb: 'https://cdn.dreamdelhi.com/dc/xxxtreme_lightning_roulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203587',
    category: 'Live Game Shows',
    gameCode: 'evo_monopolylive',
    gameName: 'Monopoly live',
    urlThumb: 'https://cdn.dreamcasino.live/evo_monopolylive.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '203588',
    category: 'Live Game Shows',
    gameCode: 'evo_lightningroulette',
    gameName: 'Lightning Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_lightningroulette.webp',
    urlBackground: '""',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '210002',
    category: 'Live Roulette',
    gameCode: 'evo_hindilightningroulette',
    gameName: 'Hindi Lightning Roulette',
    urlThumb: 'https://cdn.dreamcasino.live/evo_hindilightningroulette.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '210019',
    category: 'Video Slots',
    gameCode: 'evo_funkytime',
    gameName: 'Funky Time',
    urlThumb: 'https://cdn.dreamcasino.live/evo_funkytime.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'DC',
    subProviderName: 'Evolution Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
  {
    houseId: 1,
    gameId: '901031',
    category: 'Virtual',
    gameCode: 'RG-RT17101',
    gameName: 'VR Race To 17',
    urlThumb: 'https://cdn.dreamcasino.live/rg_rto17_vr.webp',
    urlBackground: '',
    trendingThumbnail: '',
    providerName: 'RG',
    subProviderName: 'Royal Gaming',
    status: null,
    enabled: true,
    favourite: false,
    win_casino_enabled: false,
    min_stake: 0,
    max_stake: 0,
  },
];

const allSubProviders = [
  'CRASH88 Gaming',
  'SPRIBE',
  'Royal Gaming',
  'Ezugi',
  'Evolution Gaming',
  'Pragmatic Play 2',
  'SEXYBCRT',
  'JiLi Gaming',
  'Spribe',
  'Evoplay Entertainment',
  'Caleta Gaming',
  'Pragmatic Play Live',
  'Playtech Live',
  'Smartsoft Gaming',
  'SuperNowa',
  'OneTouch',
  'Yuvi Games',
  'Royal Gaming Virtual',
  'BetGames',
  'Big Time Gaming',
  'KINGMAKER',
  'Mac88 Gaming',
  'Mac88 Gaming Virtual',
  'Monk88',
  'Booming Games',
  'Fantasma',
  'Fugaso',
];

const commonGameFilter = (games: DcGameNew[], subProviderName: string) => {
  const filteredGames = games.filter(
    (game) => game.subProviderName === subProviderName
  );

  const uniqueGames = Array.from(
    new Map(filteredGames.map((game) => [game.gameId, game])).values()
  );

  return uniqueGames;
};

export const filterCrashGames = (games: any[]) => {
  return commonGameFilter(games, 'CRASH88 Gaming');
};

export const filterMac88Games = (games: any[]) => {
  return commonGameFilter(games, 'Mac88 Gaming');
};

export const filterRoyalGamingLobby = (games: any[]) => {
  return commonGameFilter(games, 'Royal Gaming');
};

export const filterRoyalGamingVirtuals = (games: any[]) => {
  return commonGameFilter(games, 'Royal Gaming Virtual');
};

export const filterEzugiGames = (games: any[]) => {
  return commonGameFilter(games, 'Ezugi');
};
